import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, Directive, NgModule, Input, HostListener, ViewContainerRef, Component, ViewChild, CUSTOM_ELEMENTS_SCHEMA, SecurityContext, Self, Optional, Pipe } from '@angular/core';
import { BehaviorSubject, Subscription, Subject, of } from 'rxjs';
import { filter, map, switchMap, catchError } from 'rxjs/operators';
import * as i1 from '@angular/router';
import { NavigationStart } from '@angular/router';
import * as i1$2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$1 from '@angular/common/http';
import { HttpLink, InMemoryCache, ApolloClient, gql } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import * as Prismic from '@prismicio/client';
import * as PrismicDOM from '@prismicio/helpers';
import * as i2 from '@angular/platform-browser';
import * as i2$1 from '@angular/forms';
import { __decorate, __param } from 'tslib';
import * as i1$3 from 'ng-recaptcha';
import { RecaptchaV3Module } from 'ng-recaptcha';
import * as CryptoJS from 'crypto-js';

// Angular Core
const TENANTS = new InjectionToken('TENANTS');
const TENANTS_FROM_ENV = new InjectionToken('TENANTS_FROM_ENV');
const SURA_PATH = new InjectionToken('SURA_PATH');
var TenantName;
(function (TenantName) {
    TenantName["ALKOMPRAR"] = "alkomprar";
    TenantName["ALKOSTO"] = "alkosto";
    TenantName["BANCO_DE_OCCIDENTE"] = "bancodeoccidente";
    TenantName["BANCOLOMBIA"] = "bancolombia";
    TenantName["BUSQO"] = "busqo";
    TenantName["CARULLA"] = "carulla";
    TenantName["CDISCOUNT"] = "cdiscount";
    TenantName["EMPLEADOS_SURA"] = "empleadossura";
    TenantName["EURO"] = "euro";
    TenantName["EXITO"] = "exito";
    TenantName["EXITO_ATENDIDO"] = "exitoatendido";
    TenantName["EXITO_COM"] = "exitocom";
    TenantName["FLYPASS"] = "flypass";
    TenantName["FOTON"] = "foton";
    TenantName["KTRONIX"] = "ktronix";
    TenantName["PRESENTE_COM"] = "presentecom";
    TenantName["SUFI"] = "sufi";
    TenantName["SURA"] = "sura";
    TenantName["TERPEL"] = "terpel";
    TenantName["TUYA"] = "tuya";
    TenantName["VIAJES_EXITO"] = "viajesexito";
    TenantName["CLICKAM"] = "clickam";
    TenantName["COLSUBSIDIO"] = "colsubsidio";
    TenantName["EL_COLOMBIANO"] = "elcolombiano";
    TenantName["TARJETA_ALKOSTO"] = "tarjetaalkosto";
    TenantName["CHEC"] = "chec";
    TenantName["VANTI"] = "vanti";
    TenantName["RCI"] = "rci";
    TenantName["AUTOS_EXITO"] = "autosexito";
})(TenantName || (TenantName = {}));

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const environment$2 = {
    production: false,
    redirigir: false,
    suraApi: 'https://apilab.suraenlinea.com',
    suraPort: 443,
    pagosApi: 'https://suraenlineaservicios.labsura.com/ms-pagos',
    logsApi: 'https://apidigitallab.suraenlinea.com/apiventasdigitales/v1/logs',
    pagosPort: 443,
    flujoVentaApi: 'https://suraenlineaservicios.labsura.com/ms-flujo-ventas-digitales',
    flujoVentaPort: 443,
    integradorApi: 'https://suraenlineaservicios.labsura.com/ohs-ventas-digitales',
    integradorPort: 443,
    apiCifin: 'https://suraenlineaservicios.dllosura.com/ms-validacion-identidad/confronta',
    suraTimeout: 30000,
    suraPath: 'http://localhost:4200',
    prismicApi: 'https://dev.suraenlinea.com/prismic',
    ventasDigitalesApiLab: 'https://suraenlineaservicios.labsura.com/ms-flujo-ventas-digitales',
    googlereCAPTCHAKey: '6LfLzVcUAAAAAKe-UvVbGicBSh4P1VLW7WcWv-uV',
    googlereCAPTCHAKeyInvisible: '6LdRpKEUAAAAAGk0ChfHBJIj9_oVBZE1iFU3k9m-',
    googlereCAPTCHAV3Key: '6Lfrc6MZAAAAAEJJ2ouRiJ5zxliFnmWo0OGVFNzw',
    googlereCAPTCHAV3VISIBLE: '6LePc40jAAAAAFKGweziKT8zhJVi2pEQdisf5SUL',
    prismicToken: '',
    maestrosApi: 'https://suraenlineaservicios.dllosura.com/maestros',
    jqueryScript: 'https://d2cb4pggqved2u.cloudfront.net/jquery-1.11.2.min.js',
    inbentaScript: 'https://d2cb4pggqved2u.cloudfront.net/inbenta-conf.js',
    customeScript: 'https://d2cb4pggqved2u.cloudfront.net/custome.js',
    pasarelaSarlaft: 'https://ventaslab.suraenlinea.com/sarlaft',
    validacionUrl: 'https://prevalidacionpagolab.suraenlinea.com/validacion-pago',
    paisesApi: 'https://serviciospassarlaft.sura.com/gateway-sarlaft-digital',
    webchatTibotScript: 'https://parly-webchat-suraco-mastertibot.1jp7r741wpkb.us-east.codeengine.appdomain.cloud/arl/suraenlinea.html',
    webchatTibotLogo: 'https://parly-webchat-suraco-mastertibot.1jp7r741wpkb.us-east.codeengine.appdomain.cloud/arl/images/logo.png',
    headerSuscripcionNombre: 'Api-Subscription-Key',
    headerSuscripcionValor: '75b4fa90875b44d3af1db36b20f41c3f',
    moduloPagos: 'https://pagoslab.suraenlinea.com',
    tenants: [
        {
            tenant: 'sura',
            hostname: 'http://localhost:4200',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-5R4TXN',
                globalSite: 'UA-27527568-1',
                UA: 'UA-27527568-1',
                optimizeId: 'GTM-PSFM4S5',
            },
            facebookPixel: {
                code: '380531805706245',
                facebookEvents: ['PageView'],
            },
            userVoice: 'fstYbP5lDoofPPZa8JFig',
            url: '/',
            codigoCanal: '7771',
            codigoAsesor: '4999',
        },
        {
            tenant: 'bancolombia',
            hostname: 'local.suraenlinea.com:9000',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-PHSGXJ',
                UA: '',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            userVoice: 'fstYbP5lDoofPPZa8JFig',
            url: '/v2/bancolombia/soat/seguro-obligatorio',
            codigoCanal: '14619',
            codigoAsesor: '4999',
        },
        {
            tenant: 'bancodeoccidente',
            hostname: 'https://www.bancodeoccidente.com.co',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-5R4TXN',
                UA: 'UA-27527568-1',
                globalSite: 'UA-3571024-60',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            userVoice: 'fstYbP5lDoofPPZa8JFig',
            url: '/',
            codigoCanal: '301',
            codigoAsesor: '4999',
        },
    ],
    canActivateRoute: [],
    additionalGTM: [
        {
            tenant: TenantName.SURA,
            googleTagManager: {
                GTM: 'GTM-M962ZTSV',
                globalSite: '',
                UA: '',
                optimizeId: '',
            },
        },
    ],
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

var environment_dev = /*#__PURE__*/Object.freeze({
    __proto__: null,
    environment: environment$2
});

const environment$1 = {
    production: true,
    redirigir: true,
    suraApi: 'https://api.suraenlinea.com',
    suraPort: 443,
    suraTimeout: 40000,
    pagosApi: 'https://suraenlineaservicios.sura.com/ms-pagos',
    logsApi: 'https://apidigital.suraenlinea.com/apiventasdigitales/v1/logs',
    pagosPort: 443,
    integradorApi: 'https://suraenlineaservicios.sura.com/ohs-ventas-digitales',
    integradorPort: 443,
    apiCifin: 'https://suraenlineaservicios.sura.com/ms-validacion-identidad/confronta',
    suraPath: 'https://www.suraenlinea.com',
    flujoVentaApi: 'https://suraenlineaservicios.sura.com/ms-flujo-ventas-digitales',
    flujoVentaPort: 443,
    prismicApi: 'https://www.suraenlinea.com/prismic',
    googlereCAPTCHAKey: '6LfLzVcUAAAAAKe-UvVbGicBSh4P1VLW7WcWv-uV',
    googlereCAPTCHAKeyInvisible: '6LdRpKEUAAAAAGk0ChfHBJIj9_oVBZE1iFU3k9m-',
    googlereCAPTCHAV3Key: '6Lero6gZAAAAAJWti1TA3grfR98XxBIOQigmXU1G',
    googlereCAPTCHAV3VISIBLE: '6LcA2bIjAAAAAMg_8jxkYDsQoyAIqOAeWGCATy4B',
    prismicToken: 'MC5YQ1VZdFJBQUFETUFMX3VL.77-977-9Xe-_vQnvv71o77-977-9Fu-_ve-_vUEoAu-_vTMw77-977-9CSvvv71d77-977-977-977-9FG3vv73vv70',
    tokenSeus: 'XSRF-TOKEN',
    maestrosApi: 'https://suraenlineaservicios.sura.com/maestros',
    jqueryScript: 'https://d1tm5dc2ktijch.cloudfront.net/jquery-1.11.2.min.js',
    inbentaScript: 'https://d1tm5dc2ktijch.cloudfront.net/inbenta-conf.js',
    customeScript: 'https://d1tm5dc2ktijch.cloudfront.net/custome.js',
    pasarelaSarlaft: 'https://ventas.suraenlinea.com/sarlaft',
    validacionUrl: 'https://prevalidacionpago.suraenlinea.com/validacion-pago',
    paisesApi: 'https://serviciospassarlaft.sura.com/gateway-sarlaft-digital',
    webchatTibotScript: 'https://parly-webchat-suraco-mastertibot.1jp7r741wpkb.us-east.codeengine.appdomain.cloud/arl/js/chat-control.js?bot=suraenlinea',
    webchatTibotLogo: 'https://parly-webchat-suraco-mastertibot.1jp7r741wpkb.us-east.codeengine.appdomain.cloud/arl/images/logo.png',
    headerSuscripcionNombre: 'Api-Subscription-Key',
    headerSuscripcionValor: '',
    moduloPagos: 'https://pagos.suraenlinea.com',
    tenants: [
        {
            tenant: 'sura',
            hostname: 'www.suraenlinea.com',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-KWGB49',
                globalSite: 'UA-3571024-60',
                UA: 'UA-3571024-60',
                optimizeId: 'GTM-ML7FV69',
            },
            facebookPixel: {
                code: '380531805706245',
                facebookEvents: ['PageView'],
            },
            url: '/',
            codigoCanal: '7771',
            codigoAsesor: '4999',
        },
        {
            tenant: 'bancolombia',
            hostname: 'https://www.grupobancolombia.com',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-KQDGN3',
                UA: '',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            url: '/v2/bancolombia/soat/seguro-obligatorio',
            index: 'indexBancolombia',
            codigoCanal: '14619',
            codigoAsesor: '9993',
        },
        {
            tenant: 'bancodeoccidente',
            hostname: 'https://www.bancodeoccidente.com.co',
            pixelResponsys: {
                url: 'https://emailbancodeoccidente.com.co/pub/cct?_ri_=X0Gzc2X%3DAQpglLjHJlDQGtKmyRGIdp4mXLfeSMwzbSih&_ei_=EoPlssws7ktzS6UAe8DyEo0',
                width: '1',
                height: '1',
            },
            googleTagManager: {
                GTM: 'GTM-5386RGL',
                UA: 'UA-27527568-1',
                globalSite: 'UA-3571024-60',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            userVoice: 'fstYbP5lDoofPPZa8JFig',
            url: '/v2/bancodeoccidente/soat/seguro-obligatorio',
            codigoCanal: '14778',
            codigoAsesor: '55889',
        },
        {
            tenant: 'exitoatendido',
            hostname: 'https://atendido.exito.com/',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-WMV5FW9',
                UA: 'UA-131174457-35',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            userVoice: 'fstYbP5lDoofPPZa8JFig',
            url: '',
            codigoCanal: '14782',
            codigoAsesor: '4999',
        },
    ],
    canActivateRoute: [],
    additionalGTM: [
        {
            tenant: TenantName.SURA,
            googleTagManager: {
                GTM: 'GTM-M962ZTSV',
                globalSite: '',
                UA: '',
                optimizeId: '',
            },
        },
    ],
};

var environment_prod = /*#__PURE__*/Object.freeze({
    __proto__: null,
    environment: environment$1
});

const environment = {
    production: false,
    redirigir: true,
    suraApi: 'https://apilab.suraenlinea.com',
    suraPort: 443,
    pagosApi: 'https://suraenlineaservicios.labsura.com/ms-pagos',
    logsApi: 'https://apidigitallab.suraenlinea.com/apiventasdigitales/v1/logs',
    pagosPort: 443,
    flujoVentaApi: 'https://suraenlineaservicios.labsura.com/ms-flujo-ventas-digitales',
    flujoVentaPort: 443,
    integradorApi: 'https://suraenlineaservicios.labsura.com/ohs-ventas-digitales',
    integradorPort: 443,
    apiCifin: 'https://suraenlineaservicios.labsura.com/ms-validacion-identidad/confronta',
    suraTimeout: 30000,
    suraPath: 'https://lab.suraenlinea.com',
    prismicApi: 'https://lab.suraenlinea.com/prismic',
    googlereCAPTCHAKey: '6LfLzVcUAAAAAKe-UvVbGicBSh4P1VLW7WcWv-uV',
    googlereCAPTCHAKeyInvisible: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    googlereCAPTCHAV3Key: '6Lfrc6MZAAAAAEJJ2ouRiJ5zxliFnmWo0OGVFNzw',
    googlereCAPTCHAV3VISIBLE: '6LePc40jAAAAAFKGweziKT8zhJVi2pEQdisf5SUL',
    prismicToken: 'MC5YQ1VZdFJBQUFETUFMX3VL.77-977-9Xe-_vQnvv71o77-977-9Fu-_ve-_vUEoAu-_vTMw77-977-9CSvvv71d77-977-977-977-9FG3vv73vv70',
    tokenSeus: 'XSRF-TOKEN',
    maestrosApi: 'https://suraenlineaservicios.labsura.com/maestros',
    jqueryScript: 'https://d2cb4pggqved2u.cloudfront.net/jquery-1.11.2.min.js',
    inbentaScript: 'https://d2cb4pggqved2u.cloudfront.net/inbenta-conf.js',
    customeScript: 'https://d2cb4pggqved2u.cloudfront.net/custome.js',
    pasarelaSarlaft: 'https://ventaslab.suraenlinea.com/sarlaft',
    validacionUrl: 'https://prevalidacionpagolab.suraenlinea.com/validacion-pago',
    paisesApi: 'https://serviciospassarlaft.sura.com/gateway-sarlaft-digital',
    webchatTibotScript: 'https://parly-webchat-suraco-mastertibot.1jp7r741wpkb.us-east.codeengine.appdomain.cloud/arl/suraenlinea.html',
    webchatTibotLogo: 'https://parly-webchat-suraco-mastertibot.1jp7r741wpkb.us-east.codeengine.appdomain.cloud/arl/images/logo.png',
    headerSuscripcionNombre: 'Api-Subscription-Key',
    headerSuscripcionValor: '75b4fa90875b44d3af1db36b20f41c3f',
    moduloPagos: 'https://pagoslab.suraenlinea.com',
    tenants: [
        {
            tenant: 'sura',
            hostname: 'https://lab.suraenlinea.com',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-5R4TXN',
                globalSite: 'UA-27527568-1',
                UA: 'UA-27527568-1',
                optimizeId: 'GTM-PSFM4S5',
            },
            facebookPixel: {
                code: '380531805706245',
                facebookEvents: ['PageView'],
            },
            url: '/',
            codigoCanal: '7771',
            codigoAsesor: '4999',
            userVoice: 'fstYbP5lDoofPPZa8JFig',
        },
        {
            tenant: 'bancolombia',
            hostname: 'https://www.grupobancolombia.com',
            pixelResponsys: {
                url: '',
                width: '',
                height: '',
            },
            googleTagManager: {
                GTM: 'GTM-PHSGXJ',
                UA: '',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            url: '/v2/bancolombia/soat/seguro-obligatorio',
            index: 'indexBancolombia',
            codigoCanal: '346',
            codigoAsesor: '4999',
        },
        {
            tenant: 'bancodeoccidente',
            hostname: 'https://www.bancodeoccidente.com.co',
            pixelResponsys: {
                url: 'https://emailbancodeoccidente.com.co/pub/cct?_ri_=X0Gzc2X%3DAQpglLjHJlDQGtKmyRGIdp4mXLfeSMwzbSih&_ei_=EoPlssws7ktzS6UAe8DyEo0',
                width: '1',
                height: '1',
            },
            googleTagManager: {
                GTM: 'GTM-5386RGL',
                UA: 'UA-27527568-1',
                globalSite: 'UA-3571024-60',
                optimizeId: '',
            },
            facebookPixel: {
                code: '',
                facebookEvents: [''],
            },
            userVoice: 'fstYbP5lDoofPPZa8JFig',
            url: '/v2/bancodeoccidente/soat/seguro-obligatorio',
            codigoCanal: '301',
            codigoAsesor: '4999',
        },
    ],
    canActivateRoute: [],
    additionalGTM: [
        {
            tenant: TenantName.SURA,
            googleTagManager: {
                GTM: 'GTM-M962ZTSV',
                globalSite: '',
                UA: '',
                optimizeId: '',
            },
        },
    ],
};

var environment_staging = /*#__PURE__*/Object.freeze({
    __proto__: null,
    environment: environment
});

class TenantService {
    constructor(tenants, router) {
        this.tenants = tenants;
        this.router = router;
        this.currentTenant = new BehaviorSubject(null);
        this.subscription = new Subscription();
        this.getTenant = () => this.currentTenant.asObservable();
        this.getPathFromUrl();
    }
    getPathFromUrl() {
        this.subscription.add(this.router.events
            .pipe(filter((event) => event instanceof NavigationStart))
            .subscribe((event) => {
            const url = event.url === '/' ? '' : event.url;
            const pathMap = url.split('?')[0].split('/');
            this.setTenant(pathMap[1]);
        }));
    }
    setTenant(tenantName) {
        this.currentTenant.next(tenantName);
    }
    getTenantWithProps(name) {
        return this.tenants.find(t => t.name === name);
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
TenantService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantService, deps: [{ token: TENANTS }, { token: i1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
TenantService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [TENANTS]
                }] }, { type: i1.Router }]; } });

/**
 * Guard para validar si el tenant esta habilitado.
 *
 * @args
 * data: {
 *  enviroment: 'Arreglo con la lista de tenants',
 *  defaultUrlRedirectNotFound: 'Url donde se debe redireccionar en caso de no existir el tenant'
 * }
 *
 */
class TenantGuard {
    constructor(tenantService) {
        this.tenantService = tenantService;
        this.subscription = new Subscription();
        this.subscription.add(this.tenantService.getTenant().subscribe((tenant) => {
            this.tenant = tenant;
        }));
    }
    canActivate(route) {
        if (route.data.tenants.find(element => element.tenant === this.tenant)) {
            return true;
        }
        else {
            window.location.replace(route.data.defaultUrlRedirectNotFound);
            return false;
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
TenantGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantGuard, deps: [{ token: TenantService }], target: i0.ɵɵFactoryTarget.Injectable });
TenantGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: TenantService }]; } });

/**
 * Elemento (<element>) que contendrá las variables de css.
 *
 * <element libAppTenant></element>
 */
class TenantDirective {
    constructor(document, tenantService) {
        this.document = document;
        this.tenantService = tenantService;
        this.subscription = new Subscription();
    }
    ngOnInit() {
        this.subscription.add(this.tenantService.getTenant().subscribe((tenantName) => {
            if (tenantName) {
                const hasTenant = this.tenantService.getTenantWithProps(tenantName);
                if (hasTenant) {
                    this.updateTenant(hasTenant);
                }
            }
        }));
    }
    updateTenant(tenant) {
        for (const key in tenant.properties) {
            if (key) {
                this.document.body.style.setProperty(key, tenant.properties[key]);
            }
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
TenantDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantDirective, deps: [{ token: DOCUMENT }, { token: TenantService }], target: i0.ɵɵFactoryTarget.Directive });
TenantDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TenantDirective, selector: "[libAppTenant]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libAppTenant]',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: TenantService }]; } });

/**
 * Modulo que se injecta en el modulo de la apliación a usasr.
 *
 * imports: [
 *  TenantModule.forRoot([
 *      suraTenant,
 *      bancolombiaTenant
 *   ]),
 * ]
 */
class TenantModule {
    static forRoot(tenants) {
        return {
            ngModule: TenantModule,
            providers: [
                {
                    provide: TENANTS,
                    useValue: tenants,
                },
            ],
        };
    }
}
TenantModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TenantModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantModule, declarations: [TenantDirective], imports: [CommonModule], exports: [TenantDirective] });
TenantModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantModule, providers: [TenantService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TenantModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [TenantService],
                    declarations: [TenantDirective],
                    exports: [TenantDirective],
                }]
        }] });

const suraTenant = {
    name: 'sura',
    properties: {
        // Primary colors
        '--primary': '#0033a0',
        '--secondary': '#00aec7',
        '--tertiary': '#e3e829',
        '--quarter': '#53565A',
        '--error': 'red',
        '--nav-bar': '#d9e1f1',
        // Navbar
        '--color-text-nav-bar': '#0033a0',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--primary)',
        '--bg-color-button-primary': 'var(--tertiary)',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': 'var(--primary)',
        '--bg-color-button-secondary': 'var(--tertiary)',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--tertiary)',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': `'Barlow', sans-serif`,
        '--font-family-secondary-medium': `'Barlow', sans-serif`,
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/sura/logo.svg)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#00AEC7',
        '--breadcrumb-text-color': '#00AEC7',
        '--color-breadcrumb-success': '#0033A0',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': '#d9e1f1',
        '--menu-color': 'var(--primary)',
    },
};

const exitoTenant = {
    name: 'exito',
    properties: {
        // Primary colors
        '--primary': '#05c8d6',
        '--secondary': '#003466',
        '--tertiary': '#ffe800',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': 'white',
        /* Buttons */
        // Primary
        '--color-button-primary': '#05c8d6',
        '--bg-color-button-primary': '#ffe800',
        '--hover-color-button-primary': '#0e8288',
        '--hover-bg-color-button-primary': '#05c8d6',
        // Secondary
        '--color-button-secondary': '#003466',
        '--bg-color-button-secondary': '#ffe900',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#003466',
        // Tertiary
        '--color-button-tertiary': '#003466',
        '--bg-color-button-tertiary': '#ffe900',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#003466',
        // Forms
        '--color-input-valid': '#05c8d6',
        '--bg-footer': 'var(--quarter)',
        // Fonts
        '--primary-semibold-font-family': 'GalanoGrotesqueMedium',
        '--font-family-secondary': 'GalanoGrotesqueLight',
        '--font-family-secondary-medium': 'GalanoGrotesqueLight',
        // Header
        '--background-header': '#ffffff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#05c8d6',
        '--logo': 'url(./assets/images/tenants/exito/logo.png)',
        // Footer
        '--footer-color': '#fff',
        // Inputs
        '--border-success-color': '#05c8d6',
        '--label-success-color': '#05c8d6',
        '--check-success-color': '#05c8d6',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#003466',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const alkostoTenant = {
    name: 'alkosto',
    properties: {
        // Primary colors
        '--primary': '#ff5e1d',
        '--secondary': '#004590',
        '--tertiary': '#fff',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#ff5e1d',
        /* Buttons */
        // Primary
        '--color-button-primary': '#ff5e1d',
        '--bg-color-button-primary': '#fff',
        '--hover-color-button-primary': '#ff5e1d',
        '--hover-bg-color-button-primary': '#fff',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': '#df471e',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#0056a6',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': '#0056a6',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#df471e',
        // Forms
        '--color-input-valid': '#004c99',
        // Fonts
        '--primary-semibold-font-family': 'HelveticaNeueBold',
        '--font-family-secondary': 'HelveticaNeueLight',
        '--font-family-secondary-medium': 'HelveticaNeueLight',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#004590',
        '--color-breadcrumb-sucess': '#ff4611',
        '--logo': 'url(./assets/images/tenants/alkosto/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#004590',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const ktronixTenant = {
    name: 'ktronix',
    properties: {
        // Primary colors
        '--primary': '#004C99',
        '--secondary': '#707070',
        '--tertiary': '#004C99',
        '--quarter': '#004C99',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#0056a6',
        '--bg-color-button-primary': '#fff',
        '--hover-color-button-primary': '#707070',
        '--hover-bg-color-button-primary': '#fff',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': '#004C99',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#707070',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': '#0056a6',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#707070',
        // Forms
        '--color-input-valid': '#004c99',
        // Fonts
        '--primary-semibold-font-family': 'HelveticaNeueBold',
        '--font-family-secondary': 'HelveticaNeueLight',
        '--font-family-secondary-medium': 'HelveticaNeueLight',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#004590',
        '--color-breadcrumb-sucess': '#0056a6',
        '--logo': 'url(./assets/images/tenants/ktronix/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#707070',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const carullaTenant = {
    name: 'carulla',
    properties: {
        // Primary colors
        '--primary': '#8dc63f',
        '--secondary': '#005715',
        '--tertiary': '#dbdbdb',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': '#005715',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': '#005715',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': '#84BD00',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#005715',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': '#ef7c32',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#ef7c32',
        // Forms
        '--color-input-valid': '#6dc72a',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/carulla/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#005715',
        '--label-success-color': '#005715',
        '--check-success-color': '#005715',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#84BD00',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const busqoTenant = {
    name: 'busqo',
    properties: {
        // Primary colors
        '--primary': '#5e3eba',
        '--secondary': '#5e3eba',
        '--tertiary': '#7cde8d',
        '--quarter': '#755ad5',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--primary)',
        '--bg-color-button-primary': '#7cde8d',
        '--hover-color-button-primary': 'var(--primary)',
        '--hover-bg-color-button-primary': '#dbdbdb',
        // Secondary
        '--color-button-secondary': 'var(--primary)',
        '--bg-color-button-secondary': 'var(--tertiary)',
        '--hover-color-button-secondary': 'var(--primary)',
        '--bg-hover-color-button-secondary': 'var(--tertiary)',
        // Tertiary
        '--color-button-tertiary': 'var(--primary)',
        '--bg-color-button-tertiary': 'var(--tertiary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--tertiary)',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#dbdbdb',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/busqo/logo.png)',
        // Footer
        '--footer-color': '#ffffff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#5e3eba',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const cdiscountTenant = {
    name: 'cdiscount',
    properties: {
        // Primary colors
        '--primary': '#00b5cc',
        '--secondary': '#dbdbdb',
        '--tertiary': '#ffe800',
        '--quarter': '#000',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#00b5cc',
        '--bg-color-button-primary': '#ffe800',
        '--hover-color-button-primary': '#0e8288',
        '--hover-bg-color-button-primary': '#00b5cc',
        // Secondary
        '--color-button-secondary': '#0e8288',
        '--bg-color-button-secondary': '#ffe800',
        '--hover-color-button-secondary': '#0e8288',
        '--bg-hover-color-button-secondary': '#ffe800',
        // Tertiary
        '--color-button-tertiary': '#0e8288',
        '--bg-color-button-tertiary': '#ffe800',
        '--hover-color-button-tertiary': '#0e8288',
        '--bg-hover-color-button-tertiary': '#ffe800',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#00b5cc',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/cdiscount/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#dbdbdb',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const exitocomTenant = {
    name: 'exitocom',
    properties: {
        // Primary colors
        '--primary': '#000',
        '--secondary': '#EEDE29',
        '--tertiary': '#EEDE29',
        '--quarter': '#000',
        '--error': 'red',
        '--nav-bar': '#707070',
        /* Buttons */
        // Primary
        '--color-button-primary': '#00b5cc',
        '--bg-color-button-primary': '#EEDE29',
        '--hover-color-button-primary': '#201D18',
        '--hover-bg-color-button-primary': '#00b5cc',
        // Secondary
        '--color-button-secondary': '#201D18',
        '--bg-color-button-secondary': '#EEDE29',
        '--hover-color-button-secondary': '#201D18',
        '--bg-hover-color-button-secondary': '#EEDE29',
        // Tertiary
        '--color-button-tertiary': '#201D18',
        '--bg-color-button-tertiary': '#EEDE29',
        '--hover-color-button-tertiary': '#201D18',
        '--bg-hover-color-button-tertiary': '#EEDE29',
        // Forms
        '--color-input-valid': '#00b5cc',
        // Fonts
        '--primary-semibold-font-family': 'PoppinsSemiBold',
        '--font-family-secondary': 'PoppinsMedium',
        '--font-family-secondary-medium': 'Barlow',
        '--font-family-secondary-light': 'HelveticaNeueLight',
        '--font-family-keep-in-mind-header': 'PoppinsSemiBold',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#000',
        '--logo': 'url(./assets/images/tenants/exitocom/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#EEDE29',
        '--label-success-color': '#707070',
        '--check-success-color': '#707070',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#EEDE29',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const flypassTenant = {
    name: 'flypass',
    properties: {
        // Primary colors
        '--primary': '#154a96',
        '--secondary': '#fc9a18',
        '--tertiary': '#ededed',
        '--quarter': '#0033a0',
        '--error': 'red',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': 'white',
        /* Buttons */
        // Primary
        '--color-button-primary': '#000000',
        '--bg-color-button-primary': 'var(--secondary)',
        '--hover-color-button-primary': 'var(--primary)',
        '--hover-bg-color-button-primary': '#fc9a18',
        // Secondary
        '--color-button-secondary': 'var(--primary)',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': 'var(--primary)',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': 'var(--primary)',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--secondary)',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#ffffff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/flypass/logo.png)',
        // Footer
        '--footer-color': '#ffffff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#fc9a18',
        '--breadcrumb-text-color': '#fc9a18',
        '--color-breadcrumb-success': '#63ba2f',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const sufiTenant = {
    name: 'sufi',
    properties: {
        // Primary colors
        '--primary': '#FA0A3C',
        '--secondary': '#9F9F9F',
        '--tertiary': '#fff',
        '--quarter': '#434040',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--tertiary)',
        '--bg-color-button-primary': 'var(--primary)',
        '--hover-color-button-primary': 'var(--primary)',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': 'var(--tertiary)',
        '--bg-color-button-secondary': 'var(--primary)',
        '--hover-color-button-secondary': 'var(--primary)',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': 'var(--tertiary)',
        '--bg-color-button-tertiary': 'var(--primary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--secondary)',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/sufi/logo.svg)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': 'var(--quarter)',
        '--label-success-color': 'var(--quarter)',
        '--check-success-color': 'var(--quarter)',
        // Breadcrumbs
        '--breadcrumb-selected-color': 'var(--primary)',
        '--breadcrumb-text-color': '#666666',
        '--color-breadcrumb-success': 'var(--primary)',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const euroTenant = {
    name: 'euro',
    properties: {
        // Primary colors
        '--primary': '#004298',
        '--secondary': '#004298',
        '--tertiary': '#e3e829',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': '#ffe900',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': '#004298',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': '#ffe900',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#004298',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': '#ffe900',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#004298',
        // Forms
        '--color-input-valid': '#004298',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#00595f',
        '--color-breadcrumb-sucess': '#ffeb00',
        '--logo': 'url(./assets/images/tenants/euro/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#004298',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const terpelTenant = {
    name: 'terpel',
    properties: {
        // Primary colors
        '--primary': '#154a96',
        '--secondary': '#fc9a18',
        '--tertiary': '#ededed',
        '--quarter': '#0033a0',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--primary)',
        '--bg-color-button-primary': 'var(--secondary)',
        '--hover-color-button-primary': 'var(--primary)',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': 'var(--primary)',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': 'var(--primary)',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': 'var(--primary)',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--secondary)',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': 'var(--primary)',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/terpel/logo.png)',
        // Footer
        '--footer-color': '#ffffff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#fc9a18',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const bancolombiaTenant = {
    name: 'bancolombia',
    properties: {
        // Primary colors
        '--primary': '#00448D',
        '--secondary': '#FFD200',
        '--tertiary': '#F4F4F4',
        '--quarter': '#292929',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': 'var(--primary)',
        '--hover-color-button-primary': 'var(--primary)',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': '#292929',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': 'var(--primary)',
        // Tertiary
        '--color-button-tertiary': '#292929',
        '--bg-color-button-tertiary': '#FFC902',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': '#ffd601',
        // Forms
        '--color-input-valid': 'var(--primary)',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#707070',
        '--color-breadcrumb-sucess': '#00448D',
        '--logo': 'url(./assets/images/tenants/bancolombia/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': '#808285',
        // Inputs
        '--border-success-color': 'var(--primary)',
        '--label-success-color': 'var(--primary)',
        '--check-success-color': 'var(--primary)',
        // Breadcrumbs
        '--breadcrumb-selected-color': 'var(--secondary)',
        '--breadcrumb-text-color': '#84858A',
        '--color-breadcrumb-success': 'var(--primary)',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': '#f4f4f4',
        '--menu-color': '#000',
    },
};

const bancoDeOccidenteTenant = {
    name: 'bancodeoccidente',
    properties: {
        // Primary colors
        '--primary': '#008ACC',
        '--secondary': '#F8AD3B',
        '--tertiary': '#002D54',
        '--quarter': '#00124a',
        '--error': '#008acc',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': 'var(--secondary)',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#008acc',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': '#008acc',
        '--bg-hover-color-button-tertiary': '#fff',
        // Forms
        '--color-input-valid': '#008acc',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/bancodeoccidente/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#efaa23',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const exitoAtendidoTenant = {
    name: 'exitoatendido',
    properties: {
        // Primary colors
        '--primary': '#EEDE29',
        '--secondary': '#222222',
        '--tertiary': '#EEDE29',
        '--quarter': '#707070',
        '--error': 'red',
        '--nav-bar': '#707070',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--secondary)',
        '--bg-color-button-primary': '#EEDE29',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': '#201D18',
        '--bg-color-button-secondary': '#EEDE29',
        '--hover-color-button-secondary': '#201D18',
        '--bg-hover-color-button-secondary': '#EEDE29',
        // Tertiary
        '--color-button-tertiary': '#201D18',
        '--bg-color-button-tertiary': '#EEDE29',
        '--hover-color-button-tertiary': '#201D18',
        '--bg-hover-color-button-tertiary': '#EEDE29',
        // Forms
        '--color-input-valid': '#00b5cc',
        // Fonts
        '--primary-semibold-font-family': 'PoppinsSemiBold',
        '--font-family-secondary': 'PoppinsMedium',
        '--font-family-secondary-medium': 'Barlow',
        '--font-family-secondary-light': 'HelveticaNeueLight',
        '--font-family-keep-in-mind-header': 'PoppinsSemiBold',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#000',
        '--logo': 'url(./assets/images/tenants/exitocom/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#EEDE29',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const presentecomTenant = {
    name: 'presentecom',
    properties: {
        // Primary colors
        '--primary': '#515151',
        '--secondary': '#ffff00',
        '--tertiary': '#b23918',
        '--quarter': '#333333',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': '#9fc54d',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': '#808183',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': '#9fc54d',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#808183',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': '#9fc54d',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#808183',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': 'HelveticaNeueBold',
        '--font-family-secondary': 'HelveticaNeueLight',
        '--font-family-secondary-medium': 'HelveticaNeueLight',
        // Header
        '--background-header': '#fee82f',
        '--color-breadcrumb': '#808183',
        '--color-breadcrumb-sucess': '#00aec7',
        '--logo': 'url(./assets/images/tenants/presentecom/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#808183',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const alkomprarTenant = {
    name: 'alkomprar',
    properties: {
        // Primary colors
        '--primary': '#ED3833',
        '--secondary': '#FFDD00',
        '--tertiary': '#F9F9F9',
        '--quarter': '#444444',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': 'var(--secondary)',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': 'var(--primary)',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': 'var(--primary)',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': 'var(--secondary)',
        // Forms
        '--color-input-valid': 'var(--quarter)',
        // Fonts
        '--primary-semibold-font-family': 'HelveticaNeueBold',
        '--font-family-secondary': 'HelveticaNeueLight',
        '--font-family-secondary-medium': 'HelveticaNeueLight',
        // Header
        '--background-header': '#fff',
        '--logo': 'url(./assets/images/tenants/alkomprar/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--color-breadcrumb': '#84858A',
        '--color-breadcrumb-sucess': 'var(--primary)',
        '--breadcrumb-selected-color': 'var(--secondary)',
        '--breadcrumb-text-color': '#84858A',
        '--color-breadcrumb-success': 'var(--primary)',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const fotonTenant = {
    name: 'foton',
    properties: {
        // Primary colors
        '--primary': '#0B5189',
        '--secondary': '#0079B0',
        '--tertiary': '#F1F1F1',
        '--quarter': '#333333',
        '--error': '#008acc',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#fff',
        '--bg-color-button-primary': 'var(--secondary)',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': 'var(--primary)',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': 'var(--primary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--secondary)',
        '--bg-hover-color-button-tertiary': '#fff',
        // Forms
        '--color-input-valid': 'var(--secondary)',
        // Fonts
        '--primary-semibold-font-family': `'Open Sans', sans-serif `,
        '--font-family-secondary': `'Open Sans', sans-serif `,
        '--font-family-secondary-medium': `'Open Sans', sans-serif `,
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#0033a0',
        '--logo': 'url(./assets/images/tenants/foton/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': 'var(--secondary)',
        '--label-success-color': 'var(--secondary)',
        '--check-success-color': 'var(--secondary)',
        // Breadcrumbs
        '--breadcrumb-selected-color': 'var(--primary)',
        '--breadcrumb-text-color': '#84858A',
        '--color-breadcrumb-success': 'var(--secondary)',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--secondary)',
        '--menu-color': '#fff',
    },
};

const tuyaTenant = {
    name: 'tuya',
    properties: {
        // Primary colors
        '--primary': '#ed1c29',
        '--secondary': '#ffe800',
        '--tertiary': '#ffe800',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#000',
        '--bg-color-button-primary': '#ffe201',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': '#ff1525',
        // Secondary
        '--color-button-secondary': '#000',
        '--bg-color-button-secondary': '#ffe201',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#ff1525',
        // Tertiary
        '--color-button-tertiary': '#000',
        '--bg-color-button-tertiary': '#ffe201',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#ff1525',
        // Forms
        '--color-input-valid': '#00b5cc',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#b69e62',
        '--color-breadcrumb-sucess': '#ed1c29',
        '--logo': 'url(./assets/images/tenants/tuya/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#ffe800',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const empleadosSuraTenant = {
    name: 'empleadossura',
    properties: {
        // Primary colors
        '--primary': '#0033a0',
        '--secondary': '#00aec7',
        '--tertiary': '#e3e829',
        '--quarter': '#53565A',
        '--error': 'red',
        '--nav-bar': '#fff',
        /* Buttons */
        // Primary
        '--color-button-primary': '#0033a0',
        '--bg-color-button-primary': '#e3e829',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': '#00aec7',
        // Secondary
        '--color-button-secondary': 'var(--primary)',
        '--bg-color-button-secondary': 'var(--tertiary)',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': '#00aec7',
        '--hover-color-button-tertiary': '#0033a0',
        '--bg-hover-color-button-tertiary': '#e3e829',
        // Forms
        '--color-input-valid': '#00aec7',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/empleadossura/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--primary)',
        // Inputs
        '--border-success-color': '#00aec7',
        '--label-success-color': '#00aec7',
        '--check-success-color': '#00aec7',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#00aec7',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const clickamTenant = {
    name: TenantName.CLICKAM,
    properties: {
        // Primary colors
        '--primary': '#05c8d6',
        '--secondary': '#0D3862',
        '--tertiary': '#ffe800',
        '--quarter': '#53565A',
        '--error': 'red',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': 'white',
        /* Buttons */
        // Primary
        '--color-button-primary': '#05c8d6',
        '--bg-color-button-primary': '#ffe800',
        '--hover-color-button-primary': '#0e8288',
        '--hover-bg-color-button-primary': '#05c8d6',
        // Secondary
        '--color-button-secondary': '#003466',
        '--bg-color-button-secondary': '#ffe900',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#003466',
        // Tertiary
        '--color-button-tertiary': '#003466',
        '--bg-color-button-tertiary': '#ffe900',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#003466',
        // Forms
        '--color-input-valid': 'var(--primary)',
        // Fonts
        '--primary-semibold-font-family': 'GalanoGrotesqueMedium',
        '--font-family-secondary': 'GalanoGrotesqueLight',
        '--font-family-secondary-medium': 'GalanoGrotesqueLight',
        // Header
        '--background-header': '#ffffff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#05c8d6',
        '--logo': 'url(./assets/images/tenants/exito/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#05c8d6',
        '--label-success-color': '#05c8d6',
        '--check-success-color': '#05c8d6',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#003466',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const colsubsidioTenant = {
    name: 'colsubsidio',
    properties: {
        // Primary colors
        '--primary': '#00005B',
        '--secondary': '#FFCE00',
        '--tertiary': '#E6F2FF',
        '--quarter': '#011F5B',
        '--error': 'red',
        '--nav-bar': 'var(--primary)',
        // Navbar
        '--color-text-nav-bar': 'white',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--primary)',
        '--bg-color-button-primary': '#ffe800',
        '--hover-color-button-primary': '#fff',
        '--hover-bg-color-button-primary': 'var(--primary)',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': 'var(--primary)',
        '--hover-color-button-secondary': 'var(--primary)',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': 'var(--primary)',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': 'var(--primary)',
        // Forms
        '--color-input-valid': 'var(--primary)',
        // Fonts
        '--primary-semibold-font-family': 'GalanoGrotesqueMedium',
        '--font-family-secondary': 'GalanoGrotesqueLight',
        '--font-family-secondary-medium': 'GalanoGrotesqueLight',
        // Header
        '--background-header': 'var(--primary)',
        '--color-breadcrumb': '#EFEFEFDE',
        '--color-breadcrumb-sucess': '#00aec7',
        '--logo': 'url(./assets/images/tenants/colsubsidio/logo.svg)',
        // Footer
        '--footer-color': 'var(--primary)',
        '--bg-footer': '#fff',
        // Inputs
        '--border-success-color': 'var(--primary)',
        '--label-success-color': 'var(--primary)',
        '--check-success-color': 'var(--primary)',
        // Breadcrumbs
        '--color-breadcrumb-success': 'var(--white)',
        '--breadcrumb-selected-color': '#FFFFFF',
        '--breadcrumb-text-color': '#fff',
        '--breadcrumb-check-color': 'var(--primary)',
        '--color-breadcrumb-step-active': 'var(--primary)',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--secondary)',
        '--menu-color': '#fff',
    },
};

const viajesExitoTenant = {
    name: 'viajesexito',
    properties: {
        // Primary colors
        '--primary': '#05c8d6',
        '--secondary': '#003466',
        '--tertiary': '#ffe800',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': 'white',
        /* Buttons */
        // Primary
        '--color-button-primary': '#05c8d6',
        '--bg-color-button-primary': '#ffe800',
        '--hover-color-button-primary': '#0e8288',
        '--hover-bg-color-button-primary': '#05c8d6',
        // Secondary
        '--color-button-secondary': '#003466',
        '--bg-color-button-secondary': '#ffe900',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#003466',
        // Tertiary
        '--color-button-tertiary': '#003466',
        '--bg-color-button-tertiary': '#ffe900',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#003466',
        // Forms
        '--color-input-valid': '#05c8d6',
        // Fonts
        '--primary-semibold-font-family': 'GalanoGrotesqueMedium',
        '--font-family-secondary': 'GalanoGrotesqueLight',
        '--font-family-secondary-medium': 'GalanoGrotesqueLight',
        // Header
        '--background-header': '#ffffff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#05c8d6',
        '--logo': 'url(./assets/images/tenants/viajesexito/logo.svg)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#05c8d6',
        '--label-success-color': '#05c8d6',
        '--check-success-color': '#05c8d6',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#003466',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

const elColombianoTenant = {
    name: 'elcolombiano',
    properties: {
        // Primary colors
        '--primary': '#000000',
        '--secondary': '#BCCB00',
        '--tertiary': '#F4F4F4',
        '--quarter': '#fff',
        '--error': 'red',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': '#0033a0',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--secondary)',
        '--bg-color-button-primary': 'var(--secondary)',
        '--hover-color-button-primary': 'var(--quarter)',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': 'var(--quarter)',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': 'var(--quarter)',
        '--bg-hover-color-button-secondary': 'var(--primary)',
        // Tertiary
        '--color-button-tertiary': 'var(--quarter)',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--quarter)',
        '--bg-hover-color-button-tertiary': 'var(--primary)',
        // Forms
        '--color-input-valid': 'var(--secondary)',
        // Fonts
        '--primary-semibold-font-family': `'BarlowBold', sans-serif`,
        '--font-family-secondary': `'BarlowMedium', sans-serif`,
        '--font-family-secondary-medium': `'BarlowMedium', sans-serif`,
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb-sucess': 'var(--primary)',
        '--color-breadcrumb': '#707070',
        '--logo': 'url(../../../../assets/images/tenants/elcolombiano/logo.png)',
        // Footer
        '--footer-color': 'var(--quarter)',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': 'var(--primary)',
        '--label-success-color': 'var(--primary)',
        '--check-success-color': 'var(--primary)',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#FFFFFF',
        '--breadcrumb-text-color': '#fff',
        '--color-breadcrumb-success': 'var(--secondary)',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#001F5B',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--secondary)',
        '--menu-color': '#fff',
    },
};

const tarjetaAlkostoTenant = {
    name: TenantName.TARJETA_ALKOSTO,
    properties: Object.assign(Object.assign({}, alkostoTenant.properties), { '--logo': 'url(./assets/images/tenants/tarjetaalkosto/logo.png)' }),
};

const checTenant = {
    name: TenantName.CHEC,
    properties: {
        // Primary colors
        '--primary': '#008633',
        '--secondary': '#008633',
        '--tertiary': '#92C24D',
        '--quarter': '#008633',
        '--error': 'red',
        '--nav-bar': 'var(--primary)',
        // Navbar
        '--color-text-nav-bar': 'var(--primary)',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--tertiary)',
        '--bg-color-button-primary': 'transparent',
        '--hover-color-button-primary': 'var(--secondary)',
        '--hover-bg-color-button-primary': 'var(--tertiary)',
        // Secondary
        '--color-button-secondary': '#fff',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': 'var(--primary)',
        '--bg-hover-color-button-secondary': 'var(--tertiary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--tertiary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--secondary)',
        // Forms
        '--color-input-valid': 'var(--tertiary)',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': `'Barlow', sans-serif`,
        '--font-family-secondary-medium': `'Barlow', sans-serif`,
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/chec/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': 'var(--tertiary)',
        '--label-success-color': 'var(--tertiary)',
        '--check-success-color': 'var(--secondary)',
        // Breadcrumbs
        '--breadcrumb-selected-color': 'var(--primary)',
        '--breadcrumb-text-color': 'var(--primary)',
        '--color-breadcrumb-success': 'var(--secondary)',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': 'var(--primary)',
    },
};

const vantiTenant = {
    name: TenantName.VANTI,
    properties: {
        // Primary colors
        '--primary': '#00325B',
        '--secondary': '#FFCB4F',
        '--tertiary': '#e3e829',
        '--quarter': '#53565A',
        '--error': 'red',
        '--nav-bar': '#000',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--secondary)',
        '--bg-color-button-primary': 'var(--primary)',
        '--hover-color-button-primary': 'var(--primary)',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': 'var(--primary)',
        '--bg-color-button-secondary': 'var(--secondary)',
        '--hover-color-button-secondary': 'var(--secondary)',
        '--bg-hover-color-button-secondary': 'var(--primary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--tertiary)',
        // Forms
        '--color-input-valid': 'var(--primary)',
        // Fonts
        '--primary-semibold-font-family': `'FSJoeySemiBold', sans-serif`,
        '--font-family-secondary': 'Barlow',
        '--font-family-secondary-medium': 'Barlow',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#63ba2f',
        '--logo': 'url(./assets/images/tenants/vanti/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': 'var(--primary)',
        '--label-success-color': 'var(--primary)',
        '--check-success-color': 'var(--primary)',
        // Breadcrumbs
        '--breadcrumb-selected-color': 'var(--secondary)',
        '--breadcrumb-text-color': '#626262',
        '--color-breadcrumb-success': 'var(--primary)',
        '--breadcrumb-check-color': 'var(--secondary)',
        '--color-breadcrumb-step-active': 'var(--primary)',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': '#EDEDED',
        '--menu-color': '#fff',
    },
};

const rciTenant = {
    name: TenantName.RCI,
    properties: {
        // Primary colors
        '--primary': '#EC6500',
        '--secondary': '#282832',
        '--tertiary': '#FFF',
        '--quarter': '#53565A',
        '--error': '#F9423A',
        '--nav-bar': '#FFF',
        /* Buttons */
        // Primary
        '--color-button-primary': 'var(--tertiary)',
        '--bg-color-button-primary': 'var(--primary)',
        '--hover-color-button-primary': 'var(--tertiary)',
        '--hover-bg-color-button-primary': 'var(--secondary)',
        // Secondary
        '--color-button-secondary': 'var(--tertiary)',
        '--bg-color-button-secondary': 'var(--primary)',
        '--hover-color-button-secondary': 'var(--tertiary)',
        '--bg-hover-color-button-secondary': 'var(--secondary)',
        // Tertiary
        '--color-button-tertiary': '#fff',
        '--bg-color-button-tertiary': 'var(--secondary)',
        '--hover-color-button-tertiary': 'var(--primary)',
        '--bg-hover-color-button-tertiary': 'var(--tertiary)',
        // Forms
        '--color-input-valid': 'var(--primary)',
        // Fonts
        '--primary-semibold-font-family': 'Arial',
        '--font-family-secondary': 'Arial',
        '--font-family-secondary-medium': 'Arial',
        // Header
        '--background-header': '#fff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': 'var(--tertiary)',
        '--logo': 'url(./assets/images/tenants/vanti/logo.png)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': 'var(--primary)',
        '--label-success-color': 'var(--primary)',
        '--check-success-color': 'var(--primary)',
        // Breadcrumbs
        '--breadcrumb-selected-color': 'var(--primary)',
        '--breadcrumb-text-color': '#626262',
        '--color-breadcrumb-success': 'var(--tertiary)',
        '--breadcrumb-check-color': 'var(--secondary)',
        '--color-breadcrumb-step-active': 'var(--tertiary)',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': '#EDEDED',
        '--menu-color': '#fff',
    },
};

const autosExitoTenant = {
    name: TenantName.AUTOS_EXITO,
    properties: {
        // Primary colors
        '--primary': '#05c8d6',
        '--secondary': '#003466',
        '--tertiary': '#ffe800',
        '--quarter': '#54555a',
        '--error': 'red',
        '--nav-bar': '#fff',
        // Navbar
        '--color-text-nav-bar': 'white',
        /* Buttons */
        // Primary
        '--color-button-primary': '#05c8d6',
        '--bg-color-button-primary': '#ffe800',
        '--hover-color-button-primary': '#0e8288',
        '--hover-bg-color-button-primary': '#05c8d6',
        // Secondary
        '--color-button-secondary': '#003466',
        '--bg-color-button-secondary': '#ffe900',
        '--hover-color-button-secondary': '#fff',
        '--bg-hover-color-button-secondary': '#003466',
        // Tertiary
        '--color-button-tertiary': '#003466',
        '--bg-color-button-tertiary': '#ffe900',
        '--hover-color-button-tertiary': '#fff',
        '--bg-hover-color-button-tertiary': '#003466',
        // Forms
        '--color-input-valid': '#05c8d6',
        // Fonts
        '--primary-semibold-font-family': 'GalanoGrotesqueMedium',
        '--font-family-secondary': 'GalanoGrotesqueLight',
        '--font-family-secondary-medium': 'GalanoGrotesqueLight',
        // Header
        '--background-header': '#ffffff',
        '--color-breadcrumb': '#000',
        '--color-breadcrumb-sucess': '#05c8d6',
        '--logo': 'url(./assets/images/tenants/viajesexito/logo.svg)',
        // Footer
        '--footer-color': '#fff',
        '--bg-footer': 'var(--quarter)',
        // Inputs
        '--border-success-color': '#05c8d6',
        '--label-success-color': '#05c8d6',
        '--check-success-color': '#05c8d6',
        // Breadcrumbs
        '--breadcrumb-selected-color': '#003466',
        '--breadcrumb-text-color': '#000',
        '--color-breadcrumb-success': '#000',
        '--breadcrumb-check-color': '#ffff',
        '--color-breadcrumb-step-active': '#fff',
        // Angular component modal
        '--sura-color-close-modal': 'var(--bg-color-button-secondary)',
        '--sura-background-color-modal-button': 'var(--bg-color-button-secondary)',
        '--sura-color-modal-button': 'var(--color-button-secondary)',
        // Menu
        '--menu-background-color': 'var(--primary)',
        '--menu-color': '#fff',
    },
};

function ageValidator(value) {
    if (!value) {
        return 0;
    }
    let day = value.day;
    let month = value.month;
    let year = value.year;
    if (typeof value === 'string') {
        const date = value.split('/');
        year = Number(date[2]);
        month = Number(date[1]);
        day = Number(date[0]);
    }
    const today = new Date();
    const birthDate = new Date(year, month, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    if (today.getMonth() + 1 < birthDate.getMonth()) {
        age--;
    }
    if (birthDate.getMonth() === today.getMonth() + 1 &&
        today.getDate() < birthDate.getDate()) {
        age--;
    }
    return age;
}

const getDigitoVerificacion = (nit) => {
    // prettier-ignore
    const primos = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
    const modulo = 11;
    const nitArray = nit.split('');
    const result = nitArray.reduce((previousValue, currentValue, currentIndex) => {
        const indexPrimos = nitArray.length - currentIndex - 1;
        return previousValue + Number(currentValue) * primos[indexPrimos];
    }, 0);
    const residuo = result % modulo;
    const digitoVerificacion = residuo > 1 ? modulo - residuo : residuo;
    return digitoVerificacion;
};

const formatStringToDate = (stringDate) => {
    const [day, month, year] = stringDate.split('/');
    return new Date(+year, +month - 1, +day);
};
const parseDateToString = (fecha) => {
    return `${fecha.getDate()}/${fecha.getMonth() + 1}/${fecha.getFullYear()}`;
};

const regexRules = {
    regexVin: /^(?:(?![ioqñ])[a-z0-9])+$/i,
};

class SuraFormValidators {
    static isNotPresent(control) {
        const value = control.value;
        if (value === undefined || value === null) {
            return true;
        }
        return value !== '' ? false : true;
    }
    static EmailValidator(control) {
        if (SuraFormValidators.isNotPresent(control)) {
            return undefined;
        }
        if (control.value) {
            return /^([\w\.\-_]+)?\w+@[\w-_]+(\.\w+){1,}$/.test(control.value)
                ? null
                : { INVALID_EMAIL: true };
        }
    }
    static EmailUNEValidator(control) {
        if (control.value) {
            const email = control.value;
            const isInvalid = email.endsWith('@une.net.co') || email.endsWith('@miune.net');
            return isInvalid ? { INVALID_EMAIL_UNE: true } : null;
        }
    }
    static NumeroDocumentoValidador(control) {
        if (control.value) {
            return /^\d{6,10}$/.test(control.value)
                ? null
                : { INVALID_NUMERO_DOCUMENTO: true };
        }
    }
    static MinimunCharactersValidator(control) {
        if (control.value) {
            return control.value.length > 2
                ? null
                : { INVALID_MINIMUN_CHARATERS: true };
        }
    }
    static OnlyLettersValidator(control) {
        if (control.value) {
            return /^([a-zA-ZùÙüÜäàáëèéïìíöòóüùúÄÀÁËÈÉÏÌÍÖÒÓÜÚñÑ\s]+)$/.test(control.value.trim())
                ? null
                : { INVALID_ONLY_LETTERS: true };
        }
    }
    static OnlyNumbersValidator(control) {
        if (control.value) {
            return /^\d+$/.test(control.value)
                ? null
                : { INVALID_ONLY_NUMBERS: true };
        }
    }
    static NumberPhoneValidator(control) {
        if (control.value) {
            return /^(?:3(?:0[0-9]|1[0-9]|2[0-9]|5[0-1]))?\d{7}$/.test(control.value)
                ? null
                : { INVALID_NUMBER_PHONE: true };
        }
    }
    static OnlyCellPhoneValidator(control) {
        if (control.value) {
            return /^3\d{9}$/.test(control.value)
                ? null
                : { INVALID_ONLY_CELL_PHONE: true };
        }
    }
    static AddressValidator(control) {
        if (control.value) {
            return /^[A-z0-9.#;/,-]+(?: [A-z0-9.#;/,-]+)*$/.test(control.value)
                ? null
                : { INVALID_ADDRESS: true };
        }
    }
    static PlacaValidator(control) {
        if (control.value) {
            return /^[A-Z]{1,3}[0-9]{1,2}[A-Z0-9]{1,2}|[0-9]{3}[A-Z]{3}/.test(control.value.toUpperCase())
                ? null
                : { INVALID_PLACA: true };
        }
    }
    static PlacaAutomovilValidator(control) {
        if (control.value) {
            return /^[A-Z]{3}\d{3}$/.test(control.value.toUpperCase())
                ? null
                : { INVALID_PLACA_AUTOMOVIL: true };
        }
    }
    static NumeroDeTelefonoValidador(control) {
        if (control.value) {
            return /[3]([0-5])+([0-9]{8})$/.test(control.value)
                ? null
                : { INVALID_NUMBER_PHONE: true };
        }
    }
    static NumeroDeMotorValidador(control) {
        if (control.value) {
            return /^([a-zA-Z0-9_.-]*)$/.test(control.value)
                ? null
                : { INVALID_NUMERO_DE_MOTOR: true };
        }
    }
    static VinValidator(control) {
        if (control.value) {
            const vinSize = control.value.length;
            if (vinSize >= 15 && vinSize <= 17) {
                return regexRules.regexVin.test(control.value)
                    ? null
                    : { INVALID_VIN_ERRONEO: true };
            }
            else {
                return { INVALID_VIN_LONGITUD: true };
            }
        }
    }
    static NumeroDeChasisValidador(control) {
        if (control.value) {
            return /^[a-zA-Z0-9]{1,25}$/.test(control.value)
                ? null
                : { INVALID_NUMERO_DE_CHASIS: true };
        }
    }
    static PasaporteValidator(control) {
        if (control.value) {
            return /([0-9]|[a-z]){4,11}/.test(control.value)
                ? null
                : { INVALID_PASAPORTE: true };
        }
    }
    static CedulaExtranjeriaValidator(control) {
        if (control.value) {
            return /^([a-zA-Z]{1,5})?[1-9][0-9]{3,7}$/.test(control.value)
                ? null
                : { INVALID_CEDULA_EXTRANJERIA: true };
        }
    }
    static NITValidator(control) {
        const nit = control.value;
        if (nit && /^[689]\d{9}$/.test(control.value)) {
            const nitSinDigitoVerificacion = nit.substring(0, 9);
            const digitoVerificacion = nit.substring(9);
            return Number(digitoVerificacion) ===
                getDigitoVerificacion(nitSinDigitoVerificacion)
                ? null
                : { INVALID_NIT_DIGITO_VERIFICACION: true };
        }
        else {
            return { INVALID_NIT_STRUCTURE: true };
        }
    }
    static OnlyAlphanumericValidator(control) {
        if (control.value) {
            return /^[a-zA-Z0-9]+$/.test(control.value)
                ? null
                : { INVALID_ONLY_ALPHANUMERIC: true };
        }
    }
    static TerminosCondicionesValidador(control) {
        if (control.value) {
            return null;
        }
        else {
            return { INVALID_TERMINOS_CONDICIONES: true };
        }
    }
    static MayorDeEdadValidator(control) {
        return ageValidator(control.value) >= 18
            ? null
            : { INVALID_MAYOR_DE_EDAD: true };
    }
    static MaxAgeSoatValidator(control) {
        return ageValidator(control.value) <= 99 ? null : { INVALID_MAX_AGE: true };
    }
    static FechaExpedicionValidator(control) {
        return ageValidator(control.value) >= 18
            ? null
            : { INVALID_FECHA_EXPEDICION: true };
    }
    static FechaExpedicionConFechaNacimientoValidator(fechaNacimientoValue) {
        const validator = (control) => {
            if (control.value && fechaNacimientoValue) {
                const fechaNacimiento = formatStringToDate(fechaNacimientoValue);
                fechaNacimiento.setFullYear(fechaNacimiento.getFullYear() + 18);
                const fechaExpedicion = formatStringToDate(control.value);
                return fechaExpedicion >= fechaNacimiento
                    ? null
                    : {
                        INVALID_FECHA_EXPEDICION_CON_FECHA_NACIMIENTO: true,
                    };
            }
        };
        return validator;
    }
    static MenorDeEdadConTIValidator(control) {
        const currentAge = ageValidator(control.value);
        return currentAge >= 7 && currentAge < 18
            ? null
            : { INVALID_MENOR_DE_EDAD_CON_TI: true };
    }
    static MenorDeEdadConRCValidator(control) {
        return ageValidator(control.value) < 7
            ? null
            : { INVALID_MENOR_DE_EDAD_CON_RC: true };
    }
    static DocumentoMayorDeEdadValidator(control) {
        return control.value.value === 'C' || control.value.value === 'E'
            ? null
            : { INVALID_DOCUMENTO_MAYOR_DE_EDAD: true };
    }
    static DateLessTodayValidator(control) {
        if (control.value) {
            const date = formatStringToDate(control.value);
            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);
            return date <= currentDate ? null : { INVALID_DATE_LESS_TODAY: true };
        }
    }
    static DateLessThanCurrentValidator(control) {
        const ngbDate = control.value;
        if (!ngbDate) {
            return null;
        }
        const date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return date < currentDate ? null : { INVALID_DATE_LESS_THAN_CURRENT: true };
    }
    static OnlyLettersWithoutAccentMarkValidator(control) {
        if (control.value) {
            return /^([a-zA-Z\s]+)$/.test(control.value)
                ? null
                : { ONLY_LETTERS_WITHOUT_ACCENT: true };
        }
    }
    /*
      Validator que se usa para edad maxima y para asegurar que en el año se agreguen 4 digitos.
      Los condiciones que se agregan son para no eliminar la validación que ngbDate agrega por defecto.
      El typeof se usa ya que cuando se agrega una fecha mal (1--2020), el setea un string al campo en vez
      de un objeto con la fecha correcta.
    */
    static EdadMaximaValidator(edad) {
        const validator = (control) => {
            const fechaNacimiento = control.value;
            if (fechaNacimiento && typeof fechaNacimiento !== 'string' && edad) {
                if (fechaNacimiento.year.toString().length >= 4) {
                    return ageValidator(fechaNacimiento) <= edad
                        ? null
                        : { INVALID_EDAD_MAXIMA: true };
                }
                else {
                    return { INVALID_DATE: true };
                }
            }
        };
        return validator;
    }
    /*
      Valida si la fecha del control es mayor a la fecha minima ingresada como entrada.
      La fecha del control tiene que ser de tipo NgbDateStruct.
    */
    static FechaMinimaValidator(minDate, errorKey) {
        errorKey = Boolean(errorKey) ? errorKey : 'INVALID_MIN_DATE';
        const validator = (control) => {
            if (control.value) {
                const ngbDate = control.value;
                const datepickerDate = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
                datepickerDate.setHours(0, 0, 0, 0);
                return minDate <= datepickerDate ? null : { [errorKey]: true };
            }
        };
        return validator;
    }
}

class MensajesConstantesService {
    static getConstante(key) {
        return MensajesConstantesService.CONSTANTES[key];
    }
}
MensajesConstantesService.CONSTANTES = {
    REQUERIDO: 'Este campo es requerido',
    INVALID_ONLY_LETTERS: 'Ingresa únicamente letras',
    INVALID_ONLY_NUMBERS: 'Ingresa únicamente números',
    INVALID_NUMERO_DOCUMENTO: 'Documento inválido',
    INVALID_EMAIL: 'Email incorrecto',
    INVALID_ONLY_CELL_PHONE: 'Ingresa un número telefónico válido',
    INVALID_NUMBER_PHONE: 'Ingresa un número de celular válido',
    INVALID_ADDRESS: 'Ingresa una dirección valida',
    MAXIMO_CARACTERES: 'Cantidad inválida de caracteres',
    NUMERO_TARJETA_INVALIDO: 'Número de tarjeta inválido',
    NUMERO_CCV_INVALIDO: 'Código inválido de seguridad',
    ERROR_MEDIOS_DE_PAGO: 'Lo sentimos, no tienes ningún medio de pago hábilitado',
    ERROR_TARJETA_INVALIDA: 'La tarjeta de crédito no es valida.',
    FORMULARIO_INVALIDO: 'Hay un error en el formulario.',
    ERROR_PAGO_PENDIENTE: 'El pago de tu seguro está en proceso de aprobación. ' +
        'En tu correo electrónico recibirás el resultado; ' +
        'te recomendamos no repetir esta transacción hasta entonces.',
    ERROR_EXPIRACION_SESION: 'El tiempo de la sesión ha expirado, por favor intentalo nuevamente.',
    TEXTO_PAGO_PENDIENTE: 'EL pago se encuentra en un estado invalido para iniciar un proceso de pago',
    ERROR_FORMULARIO_SOAT: 'El formulario contiene datos incorrectos o sin diligenciar. Por favor inténtalo nuevamente.',
    ERROR_SERVICIO_INDISPONIBLE: 'Algo no salió bien. Por favor intentalo de nuevo más tarde.',
    // Nuevas constantes para validaciones
    REQUIRED: 'Este campo es requerido',
    INVALID_MINIMUN_CHARATERS: 'Cantidad mínima incorrecta',
    MAX: 'Cantidad máxima incorrecta',
    NGBDATE: 'Por favor seleccione una fecha valida',
    INVALID_PLACA: 'Ingrese una placa valida',
    INVALID_NUMERO_DE_MOTOR: 'El número de motor es inválido',
    INVALID_VIN_LONGITUD: 'El VIN debe tener entre 15 y 17 caracteres',
    INVALID_VIN_ERRONEO: 'El VIN no debe contener las letras I, O, Q, Ñ',
    INVALID_NUMERO_DE_CHASIS: 'El número de chasis o serie es inválido',
    FECHA_INVALIDA: 'Por favor seleccione una fecha valida',
    EDAD_MINIMA_TI: 'La edad mínima es 16 años',
    EDAD_MINIMA_INVALIDA: 'La edad mínima es 18 años',
    EDAD_MENOR_INVALIDA: 'La edad es inválida para el tipo de documento ingresado',
    EDAD_MINIMA_INVALIDAD_V2: 'La edad es inválida',
    EDAD_MAXIMA_INVALIDA_99: 'La edad máxima es 99 años',
    EDAD_MAXIMA_INVALIDA_70: 'La edad máxima es 70 años',
    MARCA_VEHICULO_INVALIDA: 'Seleccione una marca de la lista',
    LINEA_VEHICULO_INVALIDA: 'Seleccione una linea de la lista',
    CIUDAD_INVALIDA: 'Seleccione una ciudad de la lista',
    CIUDAD_INVALIDA_ORIGEN: 'Selecciona tu origen',
    CIUDAD_INVALIDA_DESTINO: 'Selecciona tu destino',
    INVALID_PASAPORTE: 'Ingrese un pasaporte valido',
    INVALID_CEDULA_EXTRANJERIA: 'Ingrese una cédula de extranjería valida',
    SOAT_NO_ENCONTRADO: 'No se encontraron pólizas asociadas a la placa y documento ingresados.',
    ERROR_RECAPTCHA: 'Ocurrió un  error validando reCaptcha de Google',
    CODIGO_ASESOR_INVALIDA: 'Ingrese un asesor valido',
    INVALID_ONLY_ALPHANUMERIC: 'Ingrese unicamente letras y números',
    SOAT_LISTANEGRA_ERROR: '004 - SOAT. Lo sentimos, no podemos gestionar tu Seguro en línea. ' +
        'Encuentra otras opciones para realizar tu compra o puedes acercarte a alguno de nuestros puntos de ' +
        'venta autorizados en tu ciudad.',
    ERROR_RECUPERAR_COTIZACION: 'Ocurrio un error al recuperar la cotización',
    // Viajes
    ERROR_ORIGEN_DESTINO: 'La ciudad de origen y destino no pueden ser la misma.',
    ERROR_VIAJERO_REPETIDO: 'No se permiten viajeros repetidos.',
    ERROR_FORMULARIO_DATOS_VIAJE: 'El formulario contiene datos incorrectos o sin diligenciar. Por favor inténtalo nuevamente.',
    ERROR_EDAD_VIAJERO: 'La edad máxima es 70 años',
};

class SuraAnclaScrollService {
    constructor() {
        this.elements = [];
    }
    scrollTo(element, duration = 500, offset = 0) {
        const subject = new Subject();
        if (typeof element === 'string') {
            const el = document.querySelector(element);
            this.scrollToElement(el, duration, offset, subject);
        }
        else if (element instanceof HTMLElement) {
            this.scrollToElement(element, duration, offset, subject);
        }
        else {
            subject.error("I don't find element");
        }
        return subject;
    }
    scrollToElement(el, duration, offset, subject) {
        if (el) {
            const viewportOffset = el.getBoundingClientRect();
            const offsetTop = viewportOffset.top + window.pageYOffset;
            this.doScrolling(offsetTop + offset, duration, subject);
        }
        else {
            subject.error("I don't find element");
        }
        return subject;
    }
    doScrolling(elementY, duration, subject) {
        const startingY = window.pageYOffset;
        const diff = elementY - startingY;
        let start;
        window.requestAnimationFrame(function step(timestamp) {
            start = !start ? timestamp : start;
            const time = timestamp - start;
            const percent = Math.min(time / duration, 1);
            window.scrollTo(0, startingY + diff * percent);
            if (time < duration) {
                window.requestAnimationFrame(step);
                subject.next({});
            }
            else {
                subject.complete();
            }
        });
    }
    saveElements(item) {
        this.elements.push(item);
    }
    getSaveElements() {
        return this.elements;
    }
}
SuraAnclaScrollService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SuraAnclaScrollService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class SuraAnclaScrollDirective {
    constructor(scrollToService, el, renderer2) {
        this.scrollToService = scrollToService;
        this.el = el;
        this.renderer2 = renderer2;
        this.elements = [];
        this.scrollToService.saveElements(el);
    }
    ngOnInit() {
        this.scrollDuration = !this.scrollDuration ? 500 : this.scrollDuration;
        this.scrollOffset = !this.scrollOffset ? 0 : this.scrollOffset;
    }
    onClick() {
        this.removeClassActive();
        this.renderer2.addClass(this.el.nativeElement, 'active');
        this.scrollToService.scrollTo(this.suraAnclaScroll, this.scrollDuration, this.scrollOffset);
    }
    removeClassActive() {
        this.scrollToService.getSaveElements().map((element) => {
            this.renderer2.removeClass(element.nativeElement, 'active');
        });
    }
}
SuraAnclaScrollDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollDirective, deps: [{ token: SuraAnclaScrollService }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
SuraAnclaScrollDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: SuraAnclaScrollDirective, selector: "[libSuraAnclaScroll]", inputs: { suraAnclaScroll: ["libSuraAnclaScroll", "suraAnclaScroll"], scrollDuration: "scrollDuration", scrollOffset: "scrollOffset" }, host: { listeners: { "click": "onClick()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[libSuraAnclaScroll]',
                }]
        }], ctorParameters: function () { return [{ type: SuraAnclaScrollService }, { type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { suraAnclaScroll: [{
                type: Input,
                args: ['libSuraAnclaScroll']
            }], scrollDuration: [{
                type: Input,
                args: ['scrollDuration']
            }], scrollOffset: [{
                type: Input,
                args: ['scrollOffset']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class SuraAnclaScrollModule {
}
SuraAnclaScrollModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraAnclaScrollModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollModule, declarations: [SuraAnclaScrollDirective], imports: [CommonModule], exports: [SuraAnclaScrollDirective] });
SuraAnclaScrollModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAnclaScrollModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SuraAnclaScrollDirective],
                    imports: [CommonModule],
                    exports: [SuraAnclaScrollDirective],
                }]
        }] });

class SetGoogleTagManagerService {
    constructor(document) {
        this.document = document;
        this.headHTMLElement = this.document.getElementsByTagName('head')[0];
        this.bodyHTMLElement = this.document.getElementsByTagName('body')[0];
    }
    setGoogleTagManager(GTM, objectGTM) {
        const s = this.document.createElement('script');
        s.type = 'text/javascript';
        const frame = this.document.createElement('noscript');
        s.innerHTML =
            '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push' +
                "({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)" +
                "[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
                "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})" +
                "(window,document,'script','dataLayer','" +
                GTM +
                "');";
        frame.innerHTML =
            '<iframe src="//www.googletagmanager.com/ns.html?id=' +
                objectGTM.GTM +
                '" height="0" width="0" style="display:none;visibility:hidden"></iframe>';
        this.headHTMLElement.appendChild(s);
        this.bodyHTMLElement.appendChild(frame);
    }
    setGoogleOptimize(GTM) {
        const s = this.document.createElement('script');
        s.type = 'text/javascript';
        s.innerHTML =
            "(function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date; h.end=i=function()" +
                "{s.className=s.className.replace(RegExp(' ?'+y),'')};" +
                '(a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;})' +
                "(window,document.documentElement,'async-hide','dataLayer',4000,{'" +
                GTM +
                "'" +
                ':true});';
        this.headHTMLElement.appendChild(s);
    }
    setPixelResponsys(objectPixel) {
        const img = this.document.createElement('img');
        img.src =
            objectPixel.url +
                ' WIDTH=' +
                objectPixel.width +
                ' HEIGHT=' +
                objectPixel.height;
        this.bodyHTMLElement.appendChild(img);
    }
}
SetGoogleTagManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SetGoogleTagManagerService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
SetGoogleTagManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SetGoogleTagManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SetGoogleTagManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class PushDatalayersGoogleTagManager {
    static push(eventName, tagName) {
        if (window['dataLayer']) {
            window['dataLayer'].push(PushDatalayersGoogleTagManager.createEvent(eventName, tagName));
        }
    }
    static createEvent(eventName, tagName) {
        return {
            event: eventName,
            accion: 'click',
            etiqueta: tagName,
        };
    }
    static addPendingEvent(eventName, tagName) {
        PushDatalayersGoogleTagManager.pendingEvents.push(PushDatalayersGoogleTagManager.createEvent(eventName, tagName));
    }
    static addPendingObject(object) {
        PushDatalayersGoogleTagManager.pendingEvents.push(object);
    }
    static pushPendingEvents() {
        PushDatalayersGoogleTagManager.pendingEvents.forEach(pendingEvent => {
            PushDatalayersGoogleTagManager.pushObject(pendingEvent);
        });
        PushDatalayersGoogleTagManager.cleanPendingEvents();
    }
    static cleanPendingEvents() {
        PushDatalayersGoogleTagManager.pendingEvents = [];
    }
    static pushPendingEventByEventName(eventName) {
        const eventPending = PushDatalayersGoogleTagManager.pendingEvents.find(event => event.event === eventName);
        if (eventPending) {
            PushDatalayersGoogleTagManager.pushObject(eventPending);
        }
    }
    static pushObject(object) {
        if (window['dataLayer']) {
            window['dataLayer'].push(object);
        }
    }
}
PushDatalayersGoogleTagManager.pendingEvents = [];

var Category;
(function (Category) {
    Category["MOVILIDAD"] = "Movilidad";
    Category["MASCOTAS"] = "Mascotas";
})(Category || (Category = {}));

var FacebookDomainVerification;
(function (FacebookDomainVerification) {
    FacebookDomainVerification["NAME"] = "facebook-domain-verification";
    FacebookDomainVerification["CONTENT"] = "5zl2wdhpbsv7nucm6b6453i4r7l3wr";
})(FacebookDomainVerification || (FacebookDomainVerification = {}));

class ObjectByTenantService {
    constructor() { }
    getObjectByTenant(env, activeTenant) {
        return env.tenants.find(x => x.tenant === activeTenant);
    }
}
ObjectByTenantService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ObjectByTenantService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ObjectByTenantService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ObjectByTenantService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ObjectByTenantService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

/**
 * @NgModule({
 *   providers: [
 *    { provide: 'asesoresUrl', useValue: 'soy/una/url' },
 *   ],
 * })
 *
 */
class SuraAsesoresService {
    constructor(httpClient, asesoresUrl) {
        this.httpClient = httpClient;
        this.asesoresUrl = asesoresUrl;
        this.asesores = new BehaviorSubject([]);
        this.codigoAsesor = new BehaviorSubject(null);
        this.asesoresTraidos = new BehaviorSubject(false);
        this.fetchAsesor = (codigo) => {
            this.httpClient
                .get(`${this.asesoresUrl}/sura/consultarAsesores?idAsesor=${codigo}`)
                .subscribe((data) => {
                if (data) {
                    this.asesores.next(data.asesores);
                    this.asesoresTraidos.next(true);
                }
            });
        };
        this.setCodigoAsesor = (codigo) => {
            this.codigoAsesor.next(codigo);
        };
        this.getAsesor = () => this.asesores.asObservable();
        this.getCodigoAsesor = () => this.codigoAsesor.asObservable();
        this.areAsesoresTraidos = () => this.asesoresTraidos.asObservable();
    }
}
SuraAsesoresService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAsesoresService, deps: [{ token: i1$1.HttpClient }, { token: 'asesoresUrl' }], target: i0.ɵɵFactoryTarget.Injectable });
SuraAsesoresService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAsesoresService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraAsesoresService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['asesoresUrl']
                }] }]; } });

class StepManagerService {
    constructor() { }
}
StepManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
StepManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class StepManagerComponent {
    constructor(componentFactoryResolver, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
    }
    ngOnInit() {
        this.stepManager.injector = this.injector;
        this.stepManager.componentFactoryResolver = this.componentFactoryResolver;
        this.stepManager.viewContainerRef = this.viewContainerRef;
    }
}
StepManagerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerComponent, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
StepManagerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: StepManagerComponent, selector: "lib-step-manager", inputs: { stepManager: "stepManager" }, viewQueries: [{ propertyName: "viewContainerRef", first: true, predicate: ["container"], descendants: true, read: ViewContainerRef }], ngImport: i0, template: `
    <div #container></div>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-step-manager',
                    template: `
    <div #container></div>
  `,
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.Injector }]; }, propDecorators: { viewContainerRef: [{
                type: ViewChild,
                args: ['container', { read: ViewContainerRef }]
            }], stepManager: [{
                type: Input
            }] } });

class StepManagerModule {
}
StepManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
StepManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerModule, declarations: [StepManagerComponent], exports: [StepManagerComponent] });
StepManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: StepManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [StepManagerComponent],
                    imports: [],
                    exports: [StepManagerComponent],
                }]
        }] });

class SuraLoadingService {
    constructor() {
        this.tags = new BehaviorSubject([]);
    }
    addLoadingTag(tag) {
        if (!this.tags.value.some(e => e === tag)) {
            const tags = this.tags.getValue();
            tags.push(tag);
            this.tags.next(tags);
        }
    }
    removeLoadingTag(tag) {
        if (this.tags.value.some(e => e === tag)) {
            let tags = this.tags.getValue();
            tags = this.tags.getValue().filter(c => c !== tag);
            this.tags.next(tags);
        }
    }
}
SuraLoadingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SuraLoadingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class SuraLoadingComponent {
    constructor(suraLoadingService) {
        this.suraLoadingService = suraLoadingService;
        this.loading = false;
        this.localTenant = 'sura';
    }
    ngOnInit() {
        this.suraLoadingService.tags.subscribe(e => {
            e.length > 0 ? (this.loading = true) : (this.loading = false);
        });
    }
}
SuraLoadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingComponent, deps: [{ token: SuraLoadingService }], target: i0.ɵɵFactoryTarget.Component });
SuraLoadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SuraLoadingComponent, selector: "lib-sura-loading", inputs: { localTenant: "localTenant" }, ngImport: i0, template: `
    <sura-loading
      [loading]="loading"
      [showlogo]="localTenant === 'sura'"
    ></sura-loading>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-sura-loading',
                    template: `
    <sura-loading
      [loading]="loading"
      [showlogo]="localTenant === 'sura'"
    ></sura-loading>
  `,
                }]
        }], ctorParameters: function () { return [{ type: SuraLoadingService }]; }, propDecorators: { localTenant: [{
                type: Input
            }] } });

class SuraLoadingModule {
}
SuraLoadingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraLoadingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingModule, declarations: [SuraLoadingComponent], imports: [CommonModule], exports: [SuraLoadingComponent] });
SuraLoadingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingModule, providers: [SuraLoadingService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraLoadingModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SuraLoadingComponent],
                    imports: [CommonModule],
                    providers: [SuraLoadingService],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    exports: [SuraLoadingComponent],
                }]
        }] });

class SuraBreadcrumbService {
    constructor() {
        this.isVisible = new BehaviorSubject(true);
        this.actualStep = new BehaviorSubject(1);
        this.steps = new BehaviorSubject([]);
    }
    setIsVisible(isVisible) {
        this.isVisible.next(isVisible);
    }
    getIsVisible() {
        return this.isVisible.asObservable();
    }
    setSteps(steps) {
        this.steps.next(steps);
    }
    getSteps() {
        return this.steps.asObservable();
    }
    setStep(step) {
        this.actualStep.next(step);
    }
    getStep() {
        return this.actualStep.asObservable();
    }
}
SuraBreadcrumbService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SuraBreadcrumbService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class SuraBreadcrumbComponent {
    constructor(suraBreadcrumbService) {
        this.suraBreadcrumbService = suraBreadcrumbService;
        this.steps = [];
        this.subscription = new Subscription();
    }
    ngOnInit() {
        this.stepsParsed = JSON.stringify(this.steps);
        this.subscription.add(this.suraBreadcrumbService.getStep().subscribe((step) => {
            this.currentStep = step;
        }));
    }
}
SuraBreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbComponent, deps: [{ token: SuraBreadcrumbService }], target: i0.ɵɵFactoryTarget.Component });
SuraBreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SuraBreadcrumbComponent, selector: "lib-sura-breadcrumb", inputs: { steps: "steps" }, ngImport: i0, template: `
    <step-breadcrumbs [steps]="stepsParsed" [currentstep]="currentStep"
      ><step-breadcrumbs></step-breadcrumbs
    ></step-breadcrumbs>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-sura-breadcrumb',
                    template: `
    <step-breadcrumbs [steps]="stepsParsed" [currentstep]="currentStep"
      ><step-breadcrumbs></step-breadcrumbs
    ></step-breadcrumbs>
  `,
                }]
        }], ctorParameters: function () { return [{ type: SuraBreadcrumbService }]; }, propDecorators: { steps: [{
                type: Input
            }] } });

class SuraBreadcrumbModule {
}
SuraBreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SuraBreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbModule, declarations: [SuraBreadcrumbComponent], imports: [CommonModule], exports: [SuraBreadcrumbComponent] });
SuraBreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbModule, providers: [SuraBreadcrumbService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SuraBreadcrumbComponent],
                    imports: [CommonModule],
                    providers: [SuraBreadcrumbService],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    exports: [SuraBreadcrumbComponent],
                }]
        }] });

class ContainerMenuService {
    constructor() {
        this.showMenu = new BehaviorSubject(true);
        this.productoActual = new Subject();
        this.urlProductoActual = new Subject();
        this.hideMenu = (modificador) => {
            this.showMenu.next(!modificador);
        };
        this.setProducto = (producto, url) => {
            this.productoActual.next(producto);
            if (url) {
                this.urlProductoActual.next(url);
            }
        };
        this.getProducto = () => this.productoActual.asObservable();
        this.getUrlProducto = () => this.urlProductoActual.asObservable();
        this.getShowMenu = () => this.showMenu.asObservable();
    }
}
ContainerMenuService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContainerMenuService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
ContainerMenuService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContainerMenuService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ContainerMenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

/**
 * @NgModule({
 *   providers: [
 *    { provide: 'addressUrl', useValue: 'soy/una/url' },
 *   ],
 * })
 *
 */
class SuraFormatAddressService {
    constructor(httpClient, addressUrl) {
        this.httpClient = httpClient;
        this.addressUrl = addressUrl;
    }
    formatAddress(address, city) {
        var _a;
        const _city = ((_a = city === null || city === void 0 ? void 0 : city.normalize('NFD')) === null || _a === void 0 ? void 0 : _a.replace(/[\u0300-\u036f]/g, '')) || city;
        return this.httpClient
            .post(`${this.addressUrl}/productos/common/format-direccion`, {
            address,
            _city,
        })
            .pipe(map((res) => res));
    }
}
SuraFormatAddressService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormatAddressService, deps: [{ token: i1$1.HttpClient }, { token: 'addressUrl' }], target: i0.ɵɵFactoryTarget.Injectable });
SuraFormatAddressService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormatAddressService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormatAddressService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['addressUrl']
                }] }]; } });

/**
 * @NgModule({
 *   providers: [
 *    { provide: 'maestrosUrl', useValue: 'soy/una/url' },
 *   ],
 * })
 *
 */
class SuraMaestrosService {
    constructor(httpClient, maestrosUrl) {
        this.httpClient = httpClient;
        this.maestrosUrl = maestrosUrl;
    }
    getMaestro(catalogo, producto) {
        return this.httpClient.get(`${this.maestrosUrl}/maestros?catalogo=${catalogo}&producto=${producto}`);
    }
}
SuraMaestrosService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraMaestrosService, deps: [{ token: i1$1.HttpClient }, { token: 'maestrosUrl' }], target: i0.ɵɵFactoryTarget.Injectable });
SuraMaestrosService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraMaestrosService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraMaestrosService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['maestrosUrl']
                }] }]; } });

const PRISMIC_ENDPOINT_REG = /^(https?):\/\/([^.]+)\.(cdn.)?([^.]+\.[^.]+)\/graphql\/?$/;
const parseURI = endpoint => {
    const [, protocol, repository, cdn, domain] = endpoint.match(PRISMIC_ENDPOINT_REG);
    if (protocol && repository && domain) {
        return {
            protocol,
            repository,
            domain,
        };
    }
    return null;
};
const PrismicLink = (prismicLinkData) => {
    const parsedURI = parseURI(prismicLinkData.uri);
    if (parseURI) {
        const { protocol, repository, domain } = parsedURI;
        const baseURI = `${protocol}://${repository}.cdn.${domain}`;
        const prismicClient = Prismic.createClient(`${baseURI}/api/v2`, {
            accessToken: prismicLinkData.accessToken,
        });
        const prismicLink = setContext((request, options) => {
            return prismicClient.getMasterRef().then(api => {
                const authorizationHeader = prismicLinkData.accessToken
                    ? { Authorization: `Token ${prismicLinkData.accessToken}` }
                    : {};
                return {
                    headers: Object.assign(Object.assign({ 'Prismic-ref': prismicLinkData.ref ? prismicLinkData.ref : api.ref }, options.headers), authorizationHeader),
                };
            });
        });
        const httpLink = new HttpLink({
            uri: `${baseURI}/graphql`,
            useGETForQueries: true,
        });
        return prismicLink.concat(httpLink);
    }
    else {
        throw new Error(`${prismicLinkData.uri} no es un endpoint válido de Prismic GraphQL`);
    }
};

class PrismicGraphqlService {
    constructor() { }
    setConfigPrismic(config) {
        const configuration = config;
        const cache = new InMemoryCache();
        const link = PrismicLink({
            uri: configuration.apiEndpoint,
            accessToken: configuration.accessToken,
            ref: configuration.ref,
        });
        this.client = new ApolloClient({
            link,
            cache,
            defaultOptions: {
                query: {
                    errorPolicy: 'all',
                },
            },
        });
    }
    executeQuery(query) {
        return this.client.query({
            query: gql `
        ${query}
      `,
        });
    }
}

class PrismicUtils {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
        this.convertTextAsHTML = (text, htmlSerializer) => {
            try {
                const richTextField = text;
                return PrismicDOM.asHTML(richTextField, null, htmlSerializer);
            }
            catch (e) {
                console.error('Error richText as HTML:', e);
            }
        };
        this.convertHTMLAsText = (html) => {
            try {
                const richHtmlField = html;
                return PrismicDOM.asText(richHtmlField, null);
            }
            catch (e) {
                console.error('Error richText as text:', e);
            }
        };
        this.convertKeyNamesToCamelCase = (data) => {
            let newO;
            let origKey;
            let newKey;
            let value;
            if (data instanceof Array) {
                return data.map(valueInArray => {
                    if (typeof valueInArray === 'object') {
                        valueInArray = this.convertKeyNamesToCamelCase(valueInArray);
                    }
                    return valueInArray;
                });
            }
            else {
                newO = {};
                for (origKey in data) {
                    if (data.hasOwnProperty(origKey)) {
                        newKey = this.convertHyphensToCamelCase(origKey);
                        value = data[origKey];
                        if (value instanceof Array ||
                            (value !== null && value.constructor === Object)) {
                            value = this.convertKeyNamesToCamelCase(value);
                        }
                        newO[newKey] = value;
                    }
                }
            }
            return newO;
        };
        this.convertHyphensToCamelCase = (textWithHyphens) => {
            return textWithHyphens.replace(/[-_]([a-z])/g, results => {
                return results[1].toUpperCase();
            });
        };
    }
    sanetizerTextHtml(textToConvert, htmlSerializer) {
        const convertHTML = this.convertTextAsHTML(textToConvert, htmlSerializer);
        const safe = this.sanitizer.sanitize(SecurityContext.HTML, convertHTML);
        return this.sanitizer.bypassSecurityTrustHtml(safe);
    }
    sanitizerUrl(securityContext, urlText) {
        const url = this.sanitizer.sanitize(securityContext, urlText);
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}
PrismicUtils.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PrismicUtils, deps: [{ token: i2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Injectable });
PrismicUtils.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PrismicUtils, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PrismicUtils, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i2.DomSanitizer }]; } });

class RenameKeyService {
    /**
     * @args keysMap
     * @args array
     *
     * Arreglo a realizar el cambio de key
     * array = [{
     *  nombre: 'SEL'
     * }];
     *
     * Objeto con el key actual y el key a cambiar
     * keysMap = {
     *  nombre: 'name'
     * }
     *
     * @return Retorna un nuevo arreglo con los nuevos key
     * newArray = [{
     *  name: 'SEL'
     * }]
     */
    static replaceKeyByMap(keysMap, array) {
        const newArray = [];
        array.map(object => {
            newArray.push(Object.keys(object).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [keysMap[key] || key]: object[key] })), {}));
        });
        return newArray;
    }
}

const isPrimitive = (test) => {
    return test !== Object(test);
};
const deepCopy = (sourceObject) => {
    const destinationObject = {};
    let value;
    // tslint:disable-next-line: forin
    for (const key in sourceObject) {
        value = sourceObject[key];
        if (typeof value !== 'object') {
            destinationObject[key] = value;
        }
        else {
            if (Array.isArray(value)) {
                destinationObject[key] = value.map(element => isPrimitive(element) ? element : deepCopy(element));
            }
            else {
                if (value instanceof Date) {
                    destinationObject[key] = new Date(value.getTime());
                }
                else if (value === null || value === undefined) {
                    destinationObject[key] = value;
                }
                else {
                    destinationObject[key] = deepCopy(value);
                }
            }
        }
    }
    return destinationObject;
};
const mapStateToProps = (stateAttrs) => {
    if (Array.isArray(stateAttrs)) {
        return stateAttrs.map(attr => mapStateToProps(attr));
    }
    if (isPrimitive(stateAttrs)) {
        return stateAttrs;
    }
    else {
        return deepCopy(stateAttrs);
    }
};

const isBase64 = (param) => {
    const base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    return base64regex.test(param);
};
const unmaskParam = (param) => {
    return atob(param);
};

const filterParamsByKey = (params, allowedParams, isMaskParam) => {
    return Object.keys(params)
        .filter(key => allowedParams.includes(key))
        .reduce((object, key) => {
        object[key] = isMaskParam
            ? isBase64(params[key])
                ? unmaskParam(params[key])
                : params[key]
            : params[key];
        return object;
    }, {});
};

const checkBooleanValue = (value) => {
    if (typeof value === 'string') {
        return value === 'true';
    }
    else {
        return value;
    }
};

var QueryParamSarlaft;
(function (QueryParamSarlaft) {
    QueryParamSarlaft["ID_COTIZACION"] = "idCotizacion";
    QueryParamSarlaft["URL_REDIRECCION"] = "urlRedireccion";
    QueryParamSarlaft["VALIDACION"] = "validacion";
    QueryParamSarlaft["ID_PROSPECTO"] = "idProspecto";
})(QueryParamSarlaft || (QueryParamSarlaft = {}));

const splitNamesOrSurnames = (text) => {
    const arrayOfValues = text.trim().split(' ');
    const firstValue = arrayOfValues[0];
    const secondValue = arrayOfValues
        .filter((value, index) => index > 0)
        .join(' ');
    return [firstValue, secondValue];
};

class SuraFormComponentsService {
    constructor(errorControl) {
        this.errorControl = errorControl;
    }
    showError(error, errorControl) {
        if (errorControl !== undefined && errorControl !== null) {
            const control = errorControl.find(e => e.key === Object.keys(error)[0]);
            if (control) {
                return control.errorMessage;
            }
        }
        else if (this.errorControl !== undefined && this.errorControl !== null) {
            const control = this.errorControl.find(e => e.key === Object.keys(error)[0]);
            if (control) {
                return control.errorMessage;
            }
        }
        else {
            return '';
        }
    }
}
SuraFormComponentsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormComponentsService, deps: [{ token: 'errorsControl' }], target: i0.ɵɵFactoryTarget.Injectable });
SuraFormComponentsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormComponentsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraFormComponentsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['errorsControl']
                }] }]; } });

class ErrorManageDirective {
    constructor(elementRef, suraFormComponentsService, control) {
        this.elementRef = elementRef;
        this.suraFormComponentsService = suraFormComponentsService;
        this.control = control;
        this.inputTextErrorControl = null;
        this.onChange = () => { };
        this.onTouched = () => { };
        // tslint:disable-next-line: no-unused-expression
        this.control && (this.control.valueAccessor = this);
    }
    get value() {
        return this._value;
    }
    set value(val) {
        if (val !== this._value) {
            this._value = val;
            this.onChange(this._value);
            this.onTouched();
            this.elementRef.nativeElement.value = val;
        }
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(val) {
        if (val !== this._disabled) {
            this._disabled = val;
            this.elementRef.nativeElement.disabled = val;
        }
    }
    listenForChange(value) {
        this.value = value;
        this.validate(this.control);
    }
    listenForBlur(value) {
        this.validate(this.control);
    }
    writeValue(value) {
        if (value) {
            if (typeof value === 'object') {
                this.value = value.value;
                this.disabled = value.disabled;
            }
            else {
                this.value = value;
            }
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    validate(c) {
        if (c.errors) {
            const error = this.suraFormComponentsService.showError(c.errors, this.inputTextErrorControl);
            this.elementRef.nativeElement.error = error;
        }
        else {
            this.elementRef.nativeElement.error = undefined;
        }
    }
    ngOnChanges(changes) {
        if (this.disabled !== undefined) {
            this.elementRef.nativeElement.disabled = this.disabled;
        }
        if (this.wasvalidate) {
            this.validate(this.control);
        }
    }
}
ErrorManageDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManageDirective, deps: [{ token: i0.ElementRef }, { token: SuraFormComponentsService }, { token: i2$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
ErrorManageDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: ErrorManageDirective, selector: "[validateErrors]", inputs: { inputTextErrorControl: "inputTextErrorControl", formStatus: "formStatus", wasvalidate: "wasvalidate" }, host: { listeners: { "change": "listenForChange($event.detail)", "blur": "listenForBlur($event.detail)" } }, providers: [], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManageDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[validateErrors]',
                    providers: [],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: SuraFormComponentsService }, { type: i2$1.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }]; }, propDecorators: { inputTextErrorControl: [{
                type: Input
            }], formStatus: [{
                type: Input
            }], wasvalidate: [{
                type: Input
            }], listenForChange: [{
                type: HostListener,
                args: ['change', ['$event.detail']]
            }], listenForBlur: [{
                type: HostListener,
                args: ['blur', ['$event.detail']]
            }] } });

class ErrorManageControlPatchedDirective extends ErrorManageDirective {
    constructor(elementRef, suraFormComponentsService, control) {
        // tslint:disable-next-line: no-unused-expression
        super(elementRef, suraFormComponentsService, control);
        this.elementRef = elementRef;
        this.suraFormComponentsService = suraFormComponentsService;
        this.control = control;
        this.subscription = new Subscription();
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    ngOnInit() {
        this.subscription.add(this.control.statusChanges.subscribe(status => {
            this.validate(this.control);
        }));
    }
}
ErrorManageControlPatchedDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManageControlPatchedDirective, deps: [{ token: i0.ElementRef }, { token: SuraFormComponentsService }, { token: i2$1.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
ErrorManageControlPatchedDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: ErrorManageControlPatchedDirective, selector: "[validateErrorsControlPatched]", providers: [], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManageControlPatchedDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[validateErrorsControlPatched]',
                    providers: [],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: SuraFormComponentsService }, { type: i2$1.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }]; } });

class ErrorManage {
}
ErrorManage.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManage, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ErrorManage.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManage, declarations: [ErrorManageDirective, ErrorManageControlPatchedDirective], exports: [ErrorManageDirective, ErrorManageControlPatchedDirective] });
ErrorManage.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManage });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ErrorManage, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ErrorManageDirective, ErrorManageControlPatchedDirective],
                    exports: [ErrorManageDirective, ErrorManageControlPatchedDirective],
                }]
        }] });

class LimitNumberDirective {
    handleKeyboardEvent(event) {
        if (this.appLimitNumberDirective) {
            const limitTo = this.appLimitNumberDirective;
            if (event.detail.value) {
                if (limitTo * 1 === event.detail.value.length) {
                    event.detail.event.preventDefault();
                }
            }
        }
    }
}
LimitNumberDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumberDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
LimitNumberDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: LimitNumberDirective, selector: "[appLimitNumberDirective]", inputs: { appLimitNumberDirective: "appLimitNumberDirective" }, host: { listeners: { "keypress": "handleKeyboardEvent($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumberDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appLimitNumberDirective]',
                }]
        }], propDecorators: { appLimitNumberDirective: [{
                type: Input
            }], handleKeyboardEvent: [{
                type: HostListener,
                args: ['keypress', ['$event']]
            }] } });

class LimitNumber {
}
LimitNumber.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumber, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LimitNumber.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumber, declarations: [LimitNumberDirective], exports: [LimitNumberDirective] });
LimitNumber.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumber });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LimitNumber, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LimitNumberDirective],
                    exports: [LimitNumberDirective],
                }]
        }] });

class Errors {
}
Errors.errorControl = [
    {
        key: 'required',
        errorMessage: 'Requerido',
    },
    {
        key: 'INVALID_ONLY_NUMBERS',
        errorMessage: 'Este campo solo permite numeros',
    },
    {
        key: 'INVALID_PLACA',
        errorMessage: 'La placa digitada es invalida',
    },
    {
        key: 'INVALID_ONLY_LETTERS',
        errorMessage: 'Este campo solo permite letras',
    },
    {
        key: 'INVALID_MINIMUN_CHARATERS',
        errorMessage: 'Este campo no cumple con el minimo de caracteres',
    },
    {
        key: 'minlength',
        errorMessage: 'Este campo no cumple con el minimo de caracteres',
    },
    {
        key: 'INVALID_ADDRESS',
        errorMessage: 'Digite una dirección valida',
    },
    {
        key: 'INVALID_EMAIL',
        errorMessage: 'Email inválido',
    },
    {
        key: 'INVALID_EMAIL_UNE',
        errorMessage: 'Correo invalido, por favor ingresa uno diferente a UNE.  ',
    },
    {
        key: 'INVALID_NUMBER_PHONE',
        errorMessage: 'Numero de telefono inválido',
    },
    {
        key: 'INVALID_FECHA_EXPEDICION_CON_FECHA_NACIMIENTO',
        errorMessage: 'La fecha de expedición debe ser mínimo 18 años posterior a la de nacimiento',
    },
    {
        key: 'INVALID_EDAD_MAXIMA',
        errorMessage: 'Supera la edad máxima',
    },
    {
        key: 'INVALID_DATE',
        errorMessage: 'Ingrese una fecha valida',
    },
    {
        key: 'INVALID_MAYOR_DE_EDAD',
        errorMessage: 'La edad mínima es 18 años',
    },
];

class ReplaceCommaPipe {
    transform(value) {
        if (value !== undefined && value !== null) {
            return value.replace(/,/g, '.');
        }
        else {
            return '';
        }
    }
}
ReplaceCommaPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ReplaceCommaPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
ReplaceCommaPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ReplaceCommaPipe, name: "replaceComma" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ReplaceCommaPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'replaceComma',
                }]
        }] });

class SuraCurrencyPipe {
    constructor(currencyPipe, replaceCommaPipe) {
        this.currencyPipe = currencyPipe;
        this.replaceCommaPipe = replaceCommaPipe;
    }
    transform(value, currencyCode = 'COP', display = 'symbol-narrow', digitsInfo = '0.0-0', locale) {
        if (value) {
            let valueParsed = value;
            const symbol = valueParsed.charAt(0);
            if (symbol === '$') {
                valueParsed = valueParsed.substring(1);
            }
            valueParsed = valueParsed.replace(/,|\./g, '');
            if (isNaN(Number(valueParsed))) {
                return value;
            }
            return this.replaceCommaPipe.transform(this.currencyPipe.transform(valueParsed, currencyCode, display, digitsInfo, locale));
        }
        return '';
    }
}
SuraCurrencyPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraCurrencyPipe, deps: [{ token: i1$2.CurrencyPipe }, { token: ReplaceCommaPipe }], target: i0.ɵɵFactoryTarget.Pipe });
SuraCurrencyPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraCurrencyPipe, name: "suraCurrency" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SuraCurrencyPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'suraCurrency' }]
        }], ctorParameters: function () { return [{ type: i1$2.CurrencyPipe }, { type: ReplaceCommaPipe }]; } });

class PipesModule {
}
PipesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PipesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, declarations: [ReplaceCommaPipe, SuraCurrencyPipe], imports: [CommonModule], exports: [ReplaceCommaPipe, SuraCurrencyPipe] });
PipesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ReplaceCommaPipe, SuraCurrencyPipe],
                    imports: [CommonModule],
                    exports: [ReplaceCommaPipe, SuraCurrencyPipe],
                }]
        }] });

let CiudadService = class CiudadService {
    constructor(url, httpClient) {
        this.url = url;
        this.httpClient = httpClient;
    }
    getCiudades(producto) {
        return this.httpClient
            .get(`${this.url}/${producto}${CiudadService.CIUDADES_ENDPOINT}`)
            .pipe(map((response) => response.respuesta));
    }
};
CiudadService.CIUDADES_ENDPOINT = '/ciudades/circulacion';
CiudadService = __decorate([
    __param(0, Inject('urlCiudadesCirculacion'))
], CiudadService);

class RecaptchaService {
    constructor(recaptchaV3Service) {
        this.recaptchaV3Service = recaptchaV3Service;
        this.reCaptchaCode = new BehaviorSubject(null);
    }
    executeActionRecaptcha(action) {
        return this.recaptchaV3Service.execute(action);
    }
    getOnExecuteListener() {
        return this.recaptchaV3Service.onExecute;
    }
    getRecaptchaCode() {
        return this.reCaptchaCode.getValue();
    }
    updateRecaptchaCode(code) {
        this.reCaptchaCode.next(code);
    }
}
RecaptchaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaService, deps: [{ token: i1$3.ReCaptchaV3Service }], target: i0.ɵɵFactoryTarget.Injectable });
RecaptchaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.ReCaptchaV3Service }]; } });

class RecaptchaModule {
}
RecaptchaModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RecaptchaModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaModule, imports: [RecaptchaV3Module] });
RecaptchaModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaModule, imports: [[RecaptchaV3Module]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: RecaptchaModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [RecaptchaV3Module],
                }]
        }] });

class ChatbotService {
    constructor(rendererFactory, document) {
        this.document = document;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    addChatbotScripts(jqueryScript, inbentaScript, customeScript) {
        const scripts = {
            jquery: jqueryScript,
            inbenta: inbentaScript,
            custome: customeScript,
        };
        Object.values(scripts).forEach((scriptSrc) => {
            const script = this.renderer.createElement('script');
            script.src = scriptSrc;
            script.type = 'text/javascript';
            this.renderer.appendChild(this.document.body, script);
        });
    }
    addChatbotTiBotScript(webchatTibotScript) {
        const scriptChat = this.renderer.createElement('script');
        scriptChat.src = webchatTibotScript;
        scriptChat.defer = true;
        this.renderer.appendChild(this.document.body, scriptChat);
    }
    addChatbotTiBotScriptTestHead(webchatTibotScript) {
        const scriptChat = this.renderer.createElement('script');
        scriptChat.src = webchatTibotScript;
        scriptChat.defer = true;
        this.renderer.appendChild(this.document.head, scriptChat);
    }
    addChatBotTiBotBubble(webchatTibotLogo) {
        const chatElementContainer = this.renderer.createElement('a');
        chatElementContainer.id = 'chatIcon';
        chatElementContainer.href = 'javascript:';
        chatElementContainer.className = 'openchat chatbot-pratech-floating';
        chatElementContainer.innerHTML = `<img
        src="${webchatTibotLogo}"
        alt="Logo Tibot"
        class="chatbot-pratech-floating-img"
      />
      <div class="chatbot-pratech-floating-span">
        Chatea con <strong>TiBot</strong>
      </div>
      <div id="notification" class="chatbot-pratech-floating-badge">
        <label id="countNotification"></label>
      </div>`;
        this.renderer.appendChild(this.document.body, chatElementContainer);
    }
}
ChatbotService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChatbotService, deps: [{ token: i0.RendererFactory2 }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
ChatbotService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChatbotService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: ChatbotService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i0.RendererFactory2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

var GoogleAnalytics;
(function (GoogleAnalytics) {
    GoogleAnalytics["GOOGLE_ID"] = "_ga=";
    GoogleAnalytics["UTM_COOKIE"] = "utm-sel";
    GoogleAnalytics["CLIENT_ID"] = "clientId";
    GoogleAnalytics[GoogleAnalytics["EXPIRE_DAYS"] = 30] = "EXPIRE_DAYS";
    GoogleAnalytics["UID_COOKIE_NAME"] = "sel_uid";
})(GoogleAnalytics || (GoogleAnalytics = {}));

class GoogleAnalyticsService {
    constructor() { }
    getGoogleId() {
        let firstGoogleClientId = null;
        if (document.cookie.match(/_ga=(.+?);/)) {
            firstGoogleClientId =
                (document &&
                    document.cookie &&
                    document.cookie
                        .match(/_ga=(.+?);/)[1]
                        .split('.')
                        .slice(-2)
                        .join('.')) ||
                    (typeof ga !== 'undefined' &&
                        ga.getAll()[0].get(GoogleAnalytics.CLIENT_ID));
        }
        return firstGoogleClientId ? firstGoogleClientId : null;
    }
    setUtmCookie(utm) {
        const decodedCookie = decodeURIComponent(document.cookie)
            .split(';')
            .filter(cookie => cookie.includes(GoogleAnalytics.UTM_COOKIE))
            .map(foundCookie => foundCookie.split('=')[1]);
        const currentDate = new Date();
        const expireDate = new Date(currentDate.getTime() + GoogleAnalytics.EXPIRE_DAYS * 24 * 60 * 60 * 1000);
        document.cookie = `${GoogleAnalytics.UTM_COOKIE}=${[
            ...decodedCookie,
            utm,
        ]}; expires=${expireDate.toUTCString()}`;
    }
    getUtmCookie() {
        const decodedCookie = decodeURIComponent(document.cookie)
            .split(';')
            .filter(cookie => cookie.includes(GoogleAnalytics.UTM_COOKIE))
            .map(foundCookie => foundCookie.split('=')[1]);
        return decodedCookie.length ? decodedCookie.toString() : null;
    }
}
GoogleAnalyticsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GoogleAnalyticsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GoogleAnalyticsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GoogleAnalyticsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GoogleAnalyticsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

var GoogleAnalyticRouteParam;
(function (GoogleAnalyticRouteParam) {
    GoogleAnalyticRouteParam["UTM_SOURCE"] = "utm_source";
})(GoogleAnalyticRouteParam || (GoogleAnalyticRouteParam = {}));

class IpAddressService {
    constructor(http) {
        this.http = http;
    }
    getIpAddress() {
        return this.http
            .get(IpAddressService.IP_URL, { params: { format: 'json' } })
            .pipe(map((response) => response.ip));
    }
}
IpAddressService.IP_URL = 'https://api.ipify.org';
IpAddressService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IpAddressService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
IpAddressService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IpAddressService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: IpAddressService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

class CurrentTimeService {
    constructor(http) {
        this.http = http;
    }
    getTime() {
        return this.http
            .get(CurrentTimeService.TIME_URL)
            .pipe(map((response) => response.datetime));
    }
}
CurrentTimeService.TIME_URL = 'https://worldtimeapi.org/api/timezone/America/Bogota';
CurrentTimeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CurrentTimeService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
CurrentTimeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CurrentTimeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: CurrentTimeService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

class DynatraceService {
    constructor() { }
    enterAction(urlODescripcion = window.location.href) {
        /* @param UrloDescripcion Url Actual o Descripción de Evento*/
        if (window.dtrum) {
            const actionId = window.dtrum.enterAction(urlODescripcion, '');
            window.dtrum.leaveAction(actionId);
        }
    }
    enterXhrAction(nombreElemento) {
        if (window.dtrum) {
            const xhrActionId = window.dtrum.enterXhrAction(nombreElemento);
            window.dtrum.leaveAction(xhrActionId);
        }
    }
    sendSessionProperties(properties) {
        if (window.dtrum) {
            window.dtrum.sendSessionProperties({}, {}, properties, {});
        }
    }
    identifyUser(value) {
        if (window.dtrum) {
            window.dtrum.identifyUser(value);
        }
    }
    reportCustomError(key, value) {
        if (window.dtrum) {
            window.dtrum.reportCustomError(key, value);
        }
    }
    reportError(value) {
        if (window.dtrum) {
            window.dtrum.reportError(value);
        }
    }
    reportCustomErrorWithAction(key, value, codeError) {
        if (window.dtrum) {
            const action = window.dtrum.enterAction(key);
            window.dtrum.reportCustomError(key, value, null, true);
            window.dtrum.addActionProperties(action, {}, {}, { detallerror: value }, { coderror: codeError });
            window.dtrum.leaveAction(action);
        }
    }
}
DynatraceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
DynatraceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class DynatraceModule {
}
DynatraceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DynatraceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceModule });
DynatraceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceModule, providers: [DynatraceService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DynatraceModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [DynatraceService],
                }]
        }] });

class PaisesService {
    constructor(httpClient, paisesApi, isProduction, headerSuscripcionValor) {
        this.httpClient = httpClient;
        this.paisesApi = paisesApi;
        this.isProduction = isProduction;
        this.headerSuscripcionValor = headerSuscripcionValor;
    }
    mockPaies() {
        return this.httpClient.get('https://apidigitallab.suraenlinea.com/pasarelasarlaft/v1/paises', {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Api-Subscription-Key': this.headerSuscripcionValor,
            },
        });
    }
    getPaises() {
        if (this.isProduction) {
            return this.httpClient.get(`${this.paisesApi}/ohs-listas-referencia/paises/consultar`);
        }
        return this.httpClient
            .get(`${this.paisesApi}/ohs-listas-referencia/paises/consultar`)
            .pipe(switchMap((response) => {
            if (response === null || response === void 0 ? void 0 : response.length) {
                return of(response);
            }
            return this.mockPaies();
        }), catchError(err => {
            return this.mockPaies();
        }));
    }
}
PaisesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaisesService, deps: [{ token: i1$1.HttpClient }, { token: 'paisesApi' }, { token: 'isProduction' }, { token: 'headerSuscripcionValor' }], target: i0.ɵɵFactoryTarget.Injectable });
PaisesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaisesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PaisesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['paisesApi']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['isProduction']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['headerSuscripcionValor']
                }] }]; } });

/**
 * Nombre de la constante que se debe inyectar en el constructor del servicio y en el providers del módulo
 */
const HEADERS_INJECTED = 'headersInjected';
/**
 * Servicio que permite inyectar headers en las peticiones http
 * Crear un servicio que implemente la interfaz IInjectHeadersHttpClient
 * Inyectar en el providers del módulo el servicio creado
 * Ejemplo:
 *  {
      provide: HEADERS_INJECTED,
      useValue: headerAzure, //IInjectHeadersHttpClient[]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InjectHeadersHttpClient,
      multi: true,
    },
 *
 */
class InjectHeadersHttpClient {
    constructor(headersInjected) {
        this.headersInjected = headersInjected;
    }
    intercept(request, next) {
        let cloneRequest = undefined;
        for (const injected of this.headersInjected) {
            if (this.isUrlIncluded(request.url, injected)) {
                const headers = this.transformHeadersToObject(injected.headers);
                cloneRequest = request.clone({
                    setHeaders: headers,
                });
            }
        }
        return next.handle(cloneRequest || request);
    }
    transformHeadersToObject(headers) {
        const headersTransformed = headers.reduce((acc, value) => {
            acc[value.name] = value.value;
            return acc;
        }, {});
        return headersTransformed;
    }
    isUrlIncluded(url, injectHeaderHttpClient) {
        return injectHeaderHttpClient.alloweds.some(link => url.includes(link));
    }
}
InjectHeadersHttpClient.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InjectHeadersHttpClient, deps: [{ token: HEADERS_INJECTED }], target: i0.ɵɵFactoryTarget.Injectable });
InjectHeadersHttpClient.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InjectHeadersHttpClient });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: InjectHeadersHttpClient, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [HEADERS_INJECTED]
                }] }]; } });

function encrypt(data, key) {
    return CryptoJS.AES.encrypt(data, key).toString();
}
function decrypt(data, key) {
    return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
}

const randomMinMax = (min = 0, max = 1) => Math.floor(Math.random() * (max - min + 1)) + min;
const createUUID = () => (new Date().getTime() + randomMinMax(0, 999)).toString(36);
function insertNonceToScripts(UUID) {
    const addNonce = (script) => {
        script.setAttribute('nonce', UUID);
    };
    const scripts = document.querySelectorAll('head script');
    const noScripts = document.querySelectorAll('head noscript');
    scripts.forEach(addNonce);
    noScripts.forEach(addNonce);
}
function createMetaCSP(domains) {
    var _a;
    (_a = window.document
        .querySelector("meta[http-equiv='Content-Security-Policy']")) === null || _a === void 0 ? void 0 : _a.remove();
    const domainsInject = ['script-src', "'unsafe-inline'", "'self'", ...domains];
    const meta = document.createElement('meta');
    meta.setAttribute('http-equiv', 'Content-Security-Policy');
    meta.setAttribute('content', domainsInject.join(' '));
    window.document.head.appendChild(meta);
}
function insertCSP(domains) {
    const UUID = createUUID();
    setTimeout(() => {
        insertNonceToScripts(UUID);
        createMetaCSP(domains);
    }, 500);
}

const ValidationsSeo = {
    URL_PATH_WITH_ID: 5, // refer to an url that contains an id at the end
};

const querySeo = (producto) => {
    return `{
        allSeo_contenidos(tags_in: ["${producto}"]) {
          edges {
            node {
              seo_data {
                url_path
                title
                canonical
                robots
                schema
                description
                twitter_title
                twitter_description
                og_title
                og_description
                og_type
                og_image
                og_image_width
                og_image_height
                fb_app_id
              }
            }
          }
        }
      }`;
};

class SeoService {
    constructor(corePrismicGraphQlService, prismicUtils, metaService, titleService, isProduction) {
        this.corePrismicGraphQlService = corePrismicGraphQlService;
        this.prismicUtils = prismicUtils;
        this.metaService = metaService;
        this.titleService = titleService;
        this.isProduction = isProduction;
        this.formattedSeoAttributes = [];
        this.getSeoData = (producto) => {
            return this.corePrismicGraphQlService
                .executeQuery(querySeo(producto))
                .then(documents => {
                const result = this.prismicUtils.convertKeyNamesToCamelCase(documents.data.allSeo_contenidos.edges[0].node);
                if (result.seoData) {
                    const seoAttributes = this.parseSeoAttributes(result.seoData);
                    return seoAttributes;
                }
                else {
                    return [];
                }
            });
        };
    }
    parseSeoAttributes(seoData) {
        let seoAttributesProperties = [];
        seoData.forEach(element => {
            const seoAttributes = {
                urlPath: this.getValue(element.urlPath),
                title: this.getValue(element.title),
                canonical: this.getValue(element.canonical),
                robots: this.getValue(element.robots),
                schema: this.getValue(element.schema),
                'name="description"': this.getValue(element.description),
                'name="twitter:title"': this.getValue(element.twitterTitle),
                'name="twitter:description"': this.getValue(element.twitterDescription),
                'property="og:title"': this.getValue(element.ogTitle),
                'property="og:description"': this.getValue(element.ogDescription),
                'property="og:type"': this.getValue(element.ogType),
                'property="og:image"': this.getValue(element.ogImage),
                'property="og:image:width"': this.getValue(element.ogImageWidth),
                'property="og:image:height"': this.getValue(element.ogImageHeight),
                'property="fb:app_id"': this.getValue(element.fbAppId),
            };
            seoAttributes.schema = seoAttributes.schema
                ? JSON.parse(seoAttributes.schema)
                : null;
            seoAttributesProperties.push(seoAttributes);
        });
        this.formattedSeoAttributes = seoAttributesProperties;
        return seoAttributesProperties;
    }
    getValue(property) {
        if (!property)
            return null;
        return Array.isArray(property) ? property[0].text : null;
    }
    getPathProperties(path) {
        this.tempSeoProperties = this.formattedSeoAttributes.find((seoData) => seoData.urlPath === path);
    }
    injectMetaInfo(path) {
        this.getPathProperties(path);
        if (this.tempSeoProperties) {
            this.updateMetaInfo();
            this.updateCanonicalLink();
            this.updateScriptBody();
            this.updateRobots();
        }
    }
    updateMetaInfo() {
        const excludeProperties = [
            'urlPath',
            'schema',
            'canonical',
            'title',
            'robots',
        ];
        if (this.tempSeoProperties.title)
            this.titleService.setTitle(this.tempSeoProperties.title);
        for (let selector in this.tempSeoProperties) {
            if (!excludeProperties.includes(selector) &&
                this.tempSeoProperties[selector]) {
                if (selector.includes('name') || selector.includes('property')) {
                    const getAttribute = selector.split('=')[1].replace(/['"]+/g, '');
                    const name = selector.includes('name') ? getAttribute : null;
                    const property = selector.includes('property') ? getAttribute : null;
                    if (this.metaService.getTag(selector)) {
                        this.metaService.updateTag({ content: this.tempSeoProperties[selector] }, selector);
                    }
                    else {
                        let objTag = {};
                        if (name) {
                            objTag = { name, content: this.tempSeoProperties[selector] };
                        }
                        if (property) {
                            objTag = { property, content: this.tempSeoProperties[selector] };
                        }
                        this.metaService.addTag(objTag);
                    }
                }
            }
            else if (!excludeProperties.includes(selector) &&
                this.metaService.getTag(selector)) {
                this.metaService.removeTag(selector);
            }
        }
    }
    updateRobots() {
        if (this.tempSeoProperties.robots) {
            const metaRobots = document.getElementById('ldRobotsSeo');
            const robotsContent = this.isProduction
                ? this.tempSeoProperties.robots
                : 'noindex, nofollow';
            if (metaRobots) {
                metaRobots.setAttribute('content', robotsContent);
            }
            else {
                this.createRobotsDom(robotsContent);
            }
        }
    }
    updateScriptBody() {
        if (this.tempSeoProperties.schema) {
            const scriptEl = document.getElementById('ldJsonScriptSeo');
            if (scriptEl) {
                scriptEl.textContent = JSON.stringify(this.tempSeoProperties.schema);
            }
            else {
                this.createSchemaDom();
            }
        }
        else {
            this.deleteSchemaDom();
        }
    }
    updateCanonicalLink() {
        const linkElement = document.getElementById('canonicalLinkSeo');
        if (this.tempSeoProperties.canonical) {
            if (linkElement) {
                linkElement.href = this.tempSeoProperties.canonical;
            }
            else {
                this.createCanonicalDom();
            }
        }
    }
    createRobotsDom(robotsContent) {
        const metaRobots = document.createElement('meta');
        metaRobots.id = 'ldRobotsSeo';
        metaRobots.name = 'robots';
        metaRobots.setAttribute('content', robotsContent);
        document.head.appendChild(metaRobots);
    }
    createSchemaDom() {
        const ldJsonScript = document.createElement('script');
        ldJsonScript.id = 'ldJsonScriptSeo';
        ldJsonScript.type = 'application/ld+json';
        ldJsonScript.textContent = JSON.stringify(this.tempSeoProperties.schema);
        document.body.appendChild(ldJsonScript);
    }
    createCanonicalDom() {
        const canonicalLink = document.createElement('link');
        canonicalLink.id = 'canonicalLinkSeo';
        canonicalLink.rel = 'canonical';
        canonicalLink.href = this.tempSeoProperties.canonical;
        document.head.appendChild(canonicalLink);
    }
    deleteSchemaDom() {
        const ldJsonScript = document.getElementById('ldJsonScriptSeo');
        if (ldJsonScript)
            document.body.removeChild(ldJsonScript);
    }
}
SeoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeoService, deps: [{ token: PrismicGraphqlService }, { token: PrismicUtils }, { token: i2.Meta }, { token: i2.Title }, { token: 'isProduction' }], target: i0.ɵɵFactoryTarget.Injectable });
SeoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeoService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeoService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: PrismicGraphqlService }, { type: PrismicUtils }, { type: i2.Meta }, { type: i2.Title }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['isProduction']
                }] }]; } });

class GenerarIdService {
    generateID(prefix = '', sufix = '') {
        const letters = {
            1: 's',
            2: 'u',
            3: 'r',
            4: 'a',
            5: 'e',
            6: 'n',
            7: 'l',
            8: 'i',
        };
        const n1 = new Date().getTime();
        const n2 = this.randomMinMax(100, 999);
        const keyLetter = this.randomMinMax(1, 8);
        const valueLetter = letters[keyLetter];
        return `${prefix}${n1 * n2}${valueLetter}${sufix}`;
    }
    randomMinMax(min = 0, max = 1) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
GenerarIdService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GenerarIdService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
GenerarIdService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GenerarIdService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: GenerarIdService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class LogService {
    constructor(httpClient, logsApi, headers, generateid) {
        this.httpClient = httpClient;
        this.logsApi = logsApi;
        this.headers = headers;
        this.generateid = generateid;
        this.clientId();
        this.requestId();
    }
    saveLog(log) {
        const _log = Object.assign(Object.assign({}, log), { fecha: new Date().getTime().toString(), clientId: this.clientId(), requestId: this.requestId(), body: log.body });
        const _logString = JSON.stringify(_log);
        return this.httpClient
            .post(`${this.logsApi}/guardar`, _logString, {
            headers: this.headers,
        })
            .toPromise();
    }
    log(log) {
        const _log = Object.assign(Object.assign({}, log), { tipoLog: 'INFO' });
        return this.saveLog(_log);
    }
    error(log) {
        const _log = Object.assign(Object.assign({}, log), { tipoLog: 'ERROR' });
        return this.saveLog(_log);
    }
    clientId() {
        const storedId = window.localStorage.getItem('clientId');
        if (storedId) {
            return storedId;
        }
        const newId = this.generateid.generateID('CLI');
        window.localStorage.setItem('clientId', newId);
        return newId;
    }
    requestId() {
        const id = this.generateid.generateID('REQ');
        return id;
    }
}
LogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LogService, deps: [{ token: i1$1.HttpClient }, { token: 'logsApi' }, { token: 'headersLog' }, { token: GenerarIdService }], target: i0.ɵɵFactoryTarget.Injectable });
LogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LogService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['logsApi']
                }] }, { type: i1$1.HttpHeaders, decorators: [{
                    type: Inject,
                    args: ['headersLog']
                }] }, { type: GenerarIdService }]; } });

/*
 * Public API Surface of commons-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Category, ChatbotService, CiudadService, ContainerMenuService, CurrentTimeService, DynatraceModule, DynatraceService, environment_dev as EnvironmentDev, environment_prod as EnvironmentProd, environment_staging as EnvironmentStaging, ErrorManage, ErrorManageControlPatchedDirective, ErrorManageDirective, Errors, FacebookDomainVerification, GenerarIdService, GoogleAnalyticRouteParam, GoogleAnalytics, GoogleAnalyticsService, HEADERS_INJECTED, InjectHeadersHttpClient, IpAddressService, LimitNumber, LimitNumberDirective, LogService, MensajesConstantesService, ObjectByTenantService, PaisesService, PipesModule, PrismicGraphqlService, PrismicLink, PrismicUtils, PushDatalayersGoogleTagManager, QueryParamSarlaft, RecaptchaModule, RecaptchaService, RenameKeyService, ReplaceCommaPipe, SURA_PATH, SeoService, SetGoogleTagManagerService, StepManagerComponent, StepManagerModule, StepManagerService, SuraAnclaScrollDirective, SuraAnclaScrollModule, SuraAnclaScrollService, SuraAsesoresService, SuraBreadcrumbComponent, SuraBreadcrumbModule, SuraBreadcrumbService, SuraCurrencyPipe, SuraFormComponentsService, SuraFormValidators, SuraFormatAddressService, SuraLoadingComponent, SuraLoadingModule, SuraLoadingService, SuraMaestrosService, TENANTS, TENANTS_FROM_ENV, TenantDirective, TenantGuard, TenantModule, TenantName, TenantService, ValidationsSeo, alkomprarTenant, alkostoTenant, autosExitoTenant, bancoDeOccidenteTenant, bancolombiaTenant, busqoTenant, carullaTenant, cdiscountTenant, checTenant, checkBooleanValue, clickamTenant, colsubsidioTenant, decrypt, deepCopy, elColombianoTenant, empleadosSuraTenant, encrypt, euroTenant, exitoAtendidoTenant, exitoTenant, exitocomTenant, filterParamsByKey, flypassTenant, formatStringToDate, fotonTenant, insertCSP, isBase64, isPrimitive, ktronixTenant, mapStateToProps, parseDateToString, presentecomTenant, querySeo, rciTenant, splitNamesOrSurnames, sufiTenant, suraTenant, tarjetaAlkostoTenant, terpelTenant, tuyaTenant, unmaskParam, vantiTenant, viajesExitoTenant };
